
// ============================================================================
// HASH-ONLY PRODUCTS CONFIGURATION
// ============================================================================
// Products in this config are hidden by default and only shown when:
// 1. URL contains their hash ID (e.g., #14808840241522)
// 2. User has the product in their cookie (30-day persistence)
// 3. Product has showInSearch: true flag (always visible in search)
//
// ⚠️ IMPORTANT: When adding a new hash product, update TWO places:
// 1. Add to HASH_ONLY_CONFIG below (with settings)
// 2. Add product ID to snippets/hash-product-ids.liquid (for search)
//
// Available settings:
// - badgeText: Custom badge text in modal (default: "Get 50% Off")
// - showInSearch: true (always show in search) | false (never show) | undefined (show only with cookie)
// - maxQuantity: Limit items per order (requires variantId)
// - variantId: Variant ID for cart quantity hiding
// - compareAtPrice: Strikethrough price in cents (e.g., 7900 = $79.00)
// - banner: Custom banner section ID to display
// - memberOnly: Only visible when member toggle is ON
// ============================================================================

const HASH_ONLY_CONFIG = {
  '14808840241522': {},  // Morel Mushroom - default badge
  '14809221726578': {  // Yellow Passion Fruit - Member Special
    badgeText: 'MEMBER SPECIAL',
    maxQuantity: 1,  // Limit to 1 per order
    variantId: '60743165346162',  // Variant ID for cart quantity hiding
    compareAtPrice: 7900,  // $79.00 strikethrough price
    banner: 'sections--25865211380082__toggle_banner_PWdQxE',  // Show specific banner (full section ID)
    memberOnly: true,  // Only visible when member toggle is ON
    showInSearch: false  // Never show in search results
  },
  '14808839750002': {},  // Lobster Mushroom - default badge
  '14811450671474': {},  // Bergamot Orange
  '14811449819506': {},  // Pink Lemon
  '14811445789042': {},  // Kaffir Lime
  '14811443528050': {},  // Buddha's Hand
  '14810227736946': {},  // Yuzu Citrus
  '14810020249970': {},  // Hachiya Persimmon
  '14811489403250': {  // Halloween Gift
    badgeText: 'HALLOWEEN SPECIAL',
    maxQuantity: 1,  // Limit to 1 per order
    variantId: '60748407800178',  // Variant ID for cart quantity hiding
    compareAtPrice: 7900,  // $79.00 strikethrough price
    banner: 'sections--25861110661490__toggle_banner_xXdVtR'  // Halloween banner
  },
  '14813440409970': {  // Fuyu Persimmon - Member Special
    badgeText: 'MEMBER SPECIAL',
    maxQuantity: 1,  // Limit to 1 per order
    variantId: '60755966919026',  // Variant ID for cart quantity hiding
    compareAtPrice: 6900  // $69.00 strikethrough price
  },
  '14816405356914': {  // Plum Variety - Member Special
    badgeText: 'MEMBER SPECIAL',
    maxQuantity: 1,  // Limit to 1 per order
    variantId: '60767295242610',  // Variant ID for cart quantity hiding
    compareAtPrice: 7900,  // $79.00 strikethrough price
    memberOnly: true,  // Only visible when member toggle is ON
    showInSearch: false  // Never show in search results
  },
  '14815562006898': {  // $1 Mystery Gift - Locked Special
    locked: true,
    lockMessage: 'Unlock $1 Box',
    klaviyoFormId: 'T6aQVW',              // Mobile form ID
    klaviyoFormIdDesktop: 'VjwLit',       // Desktop form ID
    showForUtm: ['facebook', 'instagram', 'google', 'tiktok', 'pinterest', 'snapchat', 'youtube', 'linkedin', 'twitter'],
    alwaysShow: true,  // Show without hash URL (based on UTM)
    memberOnly: true,  // Only visible when member toggle is ON
    badgeText: '$1 SPECIAL',
    maxQuantity: 1,  // Limit to 1 per order
    variantId: '60764296184178',  // Variant ID for cart quantity hiding
    compareAtPrice: 7900,  // $79.00 strikethrough price
    showInSearch: false,  // Never show in search results
    dontCountTowardsMin: true  // Don't count towards minimum item requirement
  },
  '14815184322930': {},  // Cookie-based visibility
  '14815269781874': {},  // Cookie-based visibility
  '14815217844594': {},  // Cookie-based visibility
  '14815252382066': {},  // Cookie-based visibility
  '14815253332338': {},  // Cookie-based visibility
  '14815253889394': {},  // Cookie-based visibility
  '14815264342386': {},  // Cookie-based visibility
  '14815276826994': {}   // Cookie-based visibility
  // Add more products here with custom settings
};

const HASH_ONLY_PRODUCTS = Object.keys(HASH_ONLY_CONFIG);

// Featured products - always show near top (below pinned/cookie, above best sellers)
// Order matters: first in array = highest priority
const FEATURED_PRODUCTS = [
  '14702689681778',  // Loquat
  '14747212382578',  // Red Cherry
  '14762108256626',  // Cherry Plum
  '14815265358194',  // Sumo Tangerine
  '14674145706354'   // Cacao
];

// Track which hash-only products have been revealed this session
const REVEALED_PRODUCTS = new Set();

// ============================================================================
// COOKIE UTILITIES FOR PERSISTENT HASH PRODUCT ACCESS (30-day persistence)
// ============================================================================
const HASH_COOKIE_NAME = 'ghf_hash_products';
const HASH_COOKIE_DAYS = 30;

// Get approved hash products from cookie (returns array, newest first)
function getApprovedHashProducts() {
  const value = "; " + document.cookie;
  const parts = value.split("; " + HASH_COOKIE_NAME + "=");
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(";").shift();
    return cookieValue ? cookieValue.split(',').filter(id => id) : [];
  }
  return [];
}

// Add product ID to approved list (prepends to front = newest first)
function addApprovedHashProduct(productId) {
  const approved = getApprovedHashProducts();
  
  // If already in list, remove it (we'll add to front)
  const filtered = approved.filter(id => id !== productId);
  
  // Add to front (newest first)
  filtered.unshift(productId);
  
  // Save to cookie with 30-day expiration
  const expires = new Date(Date.now() + HASH_COOKIE_DAYS * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${HASH_COOKIE_NAME}=${filtered.join(',')}; path=/; expires=${expires}; SameSite=Lax; Secure`;
  
  return filtered;
}

// Check if product is approved (in cookie)
function isProductApproved(productId) {
  return getApprovedHashProducts().includes(productId);
}

// Get all products with maxQuantity setting (for cart checking)
function getMaxQuantityProducts() {
  const products = {};
  Object.keys(HASH_ONLY_CONFIG).forEach(productId => {
    const config = HASH_ONLY_CONFIG[productId];
    if (config.maxQuantity && config.variantId) {
      products[productId] = config.variantId;
    }
  });
  return products;
}

// Check if any max-quantity products are in cart
function checkMaxQuantityProductsInCart(cartItems) {
  const maxQtyProducts = getMaxQuantityProducts();
  const inCart = {};
  
  Object.keys(maxQtyProducts).forEach(productId => {
    const variantId = maxQtyProducts[productId];
    const isInCart = cartItems.some(item => item.variant_id === parseInt(variantId));
    if (isInCart) {
      inCart[productId] = true;
    }
  });
  
  return inCart;
}

// Default banner to show on build-a-box page (when no hash-specific banner)
const DEFAULT_BUILD_A_BOX_BANNER = 'sections--25861110661490__toggle_banner_AqzxUT';
const SPECIAL_BANNER = 'sections--25861110661490__toggle_banner_JRtDgp'; // Special banner (overrides default)

// Handle banner display based on hash product config
function handleBannerTrigger(productId) {
  const bannerConfig = HASH_ONLY_CONFIG[productId]?.banner;
  
  // If no banner config for this product, check for special banner first, then default
  if (!bannerConfig) {
    // Try special banner first
    let banner = document.querySelector(`.bs-devshop__toggle-banner[data-section-id="${SPECIAL_BANNER}"]`);
    
    // If special banner not found, fall back to default
    if (!banner) {
      banner = document.querySelector(`.bs-devshop__toggle-banner[data-section-id="${DEFAULT_BUILD_A_BOX_BANNER}"]`);
    }
    
    if (banner) {
      banner.classList.remove('hidden');
      banner.style.setProperty('display', 'block', 'important');
    }
    return;
  }
  
  let banner = null;
  
  // If string: target specific banner by section ID (overrides default)
  if (typeof bannerConfig === 'string') {
    banner = document.querySelector(`.bs-devshop__toggle-banner[data-section-id="${bannerConfig}"]`);
    
    // Validation: warn if banner not found (dev mode only)
    if (!banner && window.location.search.includes('debug=1')) {
      console.warn(`⚠️ Banner not found for product ${productId}: ${bannerConfig}`);
      console.log('Available banners:', Array.from(document.querySelectorAll('.bs-devshop__toggle-banner')).map(b => b.dataset.sectionId));
    }
  }
  // If true: show first available banner
  else if (bannerConfig === true) {
    banner = document.querySelector('.bs-devshop__toggle-banner');
  }
  
  if (banner) {
    banner.classList.remove('hidden');
    banner.style.setProperty('display', 'block', 'important');
  }
}

// AB TEST: Early Sale Toggle Test (Intelligems)
// Shows Black Friday single-toggle when flag is set
(function() {
  const testVariant = sessionStorage.getItem('early_sale_toggle_test');
  if (testVariant === 'treatment') {
    document.body.classList.add('ab-test-member-toggle');
    return; // Skip member detection if AB test active
  }
})();

// Add customer status class to body for CSS targeting
(function() {
  const isActiveSubscriber = window.customer && window.customer.tags && 
    (window.customer.tags.includes('active_subscriber') ||
     window.customer.tags.includes('Priority_Pass') ||
     window.customer.tags.includes('new_member'));
  
  // FLIP SWITCH: Use isActiveSubscriber to test easier (hide for members)
  if (isActiveSubscriber) {
    document.body.classList.add('hide-regular-toggle');
  }
})();

// Hide hash-only products by default
(function() {
  const hideProducts = () => {
    HASH_ONLY_PRODUCTS.forEach(productId => {
      const config = HASH_ONLY_CONFIG[productId];
      const productElement = document.querySelector(`#product-${productId}`);
      
      if (!productElement) return;
      
      // Check if in Selected view with qty=0 - let filterProducts() handle it
      const isSelectedView = window.activeFilters?.selected;
      const qtyInput = productElement.querySelector('.juo-box__product-qty-input');
      const qty = qtyInput ? parseInt(qtyInput.value) : 0;
      
      if (isSelectedView && qty === 0) {
        // In Selected view with no qty - skip, let filterProducts() hide it
        return;
      }
      
      // If product has qty > 0, user selected it - keep it visible
      if (qty > 0) {
        productElement.style.display = 'block';
        return;
      }
      
      // Check if product should show (handles locked products with UTM targeting)
      const shouldShow = config?.locked ? 
        shouldShowLockedProduct(productId, config) : 
        (REVEALED_PRODUCTS.has(productId) || isProductApproved(productId));
      
      if (!shouldShow) {
        productElement.style.display = 'none';
        return;
      }
      
      // Product should show - check if it's locked
      if (config?.locked && !isProductUnlocked(productId)) {
        productElement.style.display = 'block';
        applyLockOverlay(productElement, productId, config);
      } else {
        productElement.style.display = 'block';
        removeLockOverlay(productElement);
      }
    });
  };
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideProducts);
  } else {
    // DOM already loaded, run immediately
    hideProducts();
  }
  
  // Also watch for dynamic product loading with MutationObserver
  const observer = new MutationObserver(() => {
    hideProducts();
  });
  
  // Start observing when products container exists
  const startObserving = () => {
    const container = document.querySelector('.juo-box__products');
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

// Reorder cookie-approved products and locked products to top
(function() {
  const reorderCookieProducts = () => {
    const productContainer = document.querySelector('.juo-box__products');
    if (!productContainer) return;
    
    // PRIORITY 0: Pin UTM gift products to the very top (highest priority)
    const utmSource = getUtmSource(); // Check URL, sessionStorage, and 30-day cookie
    
    if (utmSource) {
      const utmGiftProducts = HASH_ONLY_PRODUCTS.filter(productId => {
        const config = HASH_ONLY_CONFIG[productId];
        if (!config?.showForUtm) return false;
        
        const matchesUtm = config.showForUtm.includes(utmSource);
        if (!matchesUtm) return false;
        
        const productElement = document.querySelector(`#product-${productId}`);
        if (!productElement) return false;
        
        // Only pin if product is actually showing
        return productElement.style.display !== 'none';
      });
      
      // Move UTM gift products to top (in reverse order)
      for (let i = utmGiftProducts.length - 1; i >= 0; i--) {
        const productId = utmGiftProducts[i];
        const productElement = document.querySelector(`#product-${productId}`);
        
        if (productElement && productElement.parentNode === productContainer) {
          productContainer.insertBefore(productElement, productContainer.firstChild);
        }
      }
    }
    
    // PRIORITY 1: Pin locked products below UTM gifts (if showing)
    const lockedProducts = HASH_ONLY_PRODUCTS.filter(productId => {
      const config = HASH_ONLY_CONFIG[productId];
      if (!config?.locked) return false;
      
      const productElement = document.querySelector(`#product-${productId}`);
      if (!productElement) return false;
      
      // Only pin if product is actually showing
      return productElement.style.display !== 'none';
    });
    
    // Move locked products to top (in reverse order so first locked product ends up at position 0)
    for (let i = lockedProducts.length - 1; i >= 0; i--) {
      const productId = lockedProducts[i];
      const productElement = document.querySelector(`#product-${productId}`);
      
      if (productElement && productElement.parentNode === productContainer) {
        productContainer.insertBefore(productElement, productContainer.firstChild);
      }
    }
    
    // PRIORITY 2: Pin cookie-approved products below locked products
    const approvedProducts = getApprovedHashProducts(); // Array of product IDs, newest first
    if (approvedProducts.length > 0) {
      // Move approved products to top in reverse order (so newest ends up first)
      // We go backwards through the array so the first item (newest) ends up at position 0
      for (let i = approvedProducts.length - 1; i >= 0; i--) {
        const productId = approvedProducts[i];
        const productElement = document.querySelector(`#product-${productId}`);
        
        if (productElement && productElement.parentNode === productContainer) {
          // Move to top (but will be below locked products due to order of execution)
          productContainer.insertBefore(productElement, productContainer.firstChild);
        }
      }
    }
    
    // After reordering, apply featured product sorting
    setTimeout(() => {
      if (typeof window.filterProducts === 'function') {
        window.filterProducts(true);
      }
    }, 100);
  };
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderCookieProducts);
  } else {
    reorderCookieProducts();
  }
})();

// Show default banner on build-a-box page (if no hash or hash product has no custom banner)
(function() {
  // Wait for DOM to be ready
  const showDefaultBanner = () => {
    // Try special banner first
    let banner = document.querySelector(`.bs-devshop__toggle-banner[data-section-id="${SPECIAL_BANNER}"]`);
    
    // If special banner not found, fall back to default
    if (!banner) {
      banner = document.querySelector(`.bs-devshop__toggle-banner[data-section-id="${DEFAULT_BUILD_A_BOX_BANNER}"]`);
    }
    
    if (banner) {
      banner.classList.remove('hidden');
      banner.style.setProperty('display', 'block', 'important');
    }
  };
  
  // If no hash, show default banner immediately
  if (!window.location.hash) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showDefaultBanner);
    } else {
      showDefaultBanner();
    }
  }
})();

// Early modal detection - run immediately if hash exists
(function() {
  if (window.location.hash) {
    // Inject critical CSS immediately to prevent any flicker
    const style = document.createElement('style');
    style.textContent = '.juo-box__products { opacity: 0 !important; }';
    style.id = 'modal-pending-style';
    document.head?.appendChild(style);
    
    // Add class to prevent flicker
    document.body?.classList.add('modal-pending');
    
    const checkAndOpen = () => {
      // Extract hash and strip any UTM parameters (e.g., #14809221726578?utm_source=...)
      const hash = window.location.hash.slice(1).split('?')[0];
      if (!hash) return;
      
      // DETECT AND REVEAL UTM GIFT PRODUCTS FIRST
      const utmSource = getUtmSource(); // Check URL, sessionStorage, and 30-day cookie
      
      if (utmSource) {
        // Find and reveal UTM gift products
        Object.keys(HASH_ONLY_CONFIG).forEach(productId => {
          const config = HASH_ONLY_CONFIG[productId];
          if (config.showForUtm && config.showForUtm.includes(utmSource)) {
            const giftElement = document.querySelector(`#product-${productId}`);
            if (giftElement && HASH_ONLY_PRODUCTS.includes(productId)) {
              giftElement.style.display = 'block';
              REVEALED_PRODUCTS.add(productId);
              addApprovedHashProduct(productId); // Save to cookie
            }
          }
        });
      }
      
      const productElement = document.querySelector(`#product-${hash}`);
      if (productElement) {
        // If this is a hash-only product, show it and mark as revealed
        if (HASH_ONLY_PRODUCTS.includes(hash)) {
          productElement.style.display = 'block';
          REVEALED_PRODUCTS.add(hash);
          addApprovedHashProduct(hash); // Save to cookie for future visits
          
          // Handle banner trigger
          handleBannerTrigger(hash);
        }
        
        const iconElement = productElement.querySelector('.juo-box__product-icon');
        if (iconElement) {
          // Found it - click immediately
          iconElement.click();
          
          // REORDER: Move hash product to top of grid
          const productContainer = document.querySelector('.juo-box__products');
          if (productContainer && productElement.parentNode === productContainer) {
            productContainer.insertBefore(productElement, productContainer.firstChild);
            
            // PIN RELATED PRODUCTS: Get related products and pin them after hash product
            const relatedProductsData = productElement.getAttribute('data-related-products');
            if (relatedProductsData && relatedProductsData.trim()) {
              const relatedIds = relatedProductsData.split(',').map(id => id.trim()).filter(id => id);
              
              // Pin each related product in order (after the hash product)
              // Hash product is at position 0, so related products go at 1, 2, 3, etc.
              relatedIds.forEach((relatedId, index) => {
                const relatedElement = document.querySelector(`#product-${relatedId}`);
                if (relatedElement && relatedElement.parentNode === productContainer) {
                  // If related product is hash-only, reveal it
                  if (HASH_ONLY_PRODUCTS.includes(relatedId)) {
                    relatedElement.style.display = 'block';
                    REVEALED_PRODUCTS.add(relatedId);
                    addApprovedHashProduct(relatedId); // Save to cookie for future visits
                  }
                  
                  // Insert at position index+1 (after hash product and previous related products)
                  // Use productContainer.children[index + 1] as reference
                  const targetPosition = index + 1;
                  const referenceElement = productContainer.children[targetPosition];
                  
                  // Only insert if the element is not already in the correct position
                  if (productContainer.children[targetPosition] !== relatedElement) {
                    productContainer.insertBefore(relatedElement, referenceElement);
                  }
                }
              });
            }
          }
          
          // Remove pending class and style since modal is now open
          document.body?.classList.remove('modal-pending');
          document.getElementById('modal-pending-style')?.remove();
          return true;
        }
      }
      return false;
    };
    
    // Try immediately
    if (!checkAndOpen()) {
      // If not found, watch for it
      const observer = new MutationObserver((mutations, obs) => {
        if (checkAndOpen()) {
          obs.disconnect();
        }
      });
      
      // Set a timeout to show content anyway if product not found
      setTimeout(() => {
        document.body?.classList.remove('modal-pending');
        document.body?.classList.add('modal-ready');
        document.getElementById('modal-pending-style')?.remove();
      }, 500); // Show content after 500ms regardless
      
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          if (!document.body.classList.contains('modal-pending')) {
            document.body.classList.add('modal-pending');
          }
          observer.observe(document.body, { childList: true, subtree: true });
        });
      }
    }
  }
})();

(function () {
  let n = 0;


  
function c(e) {
    const u = e.reduce(function (a, r) {
      return Math.max(a, r.productsCount);
    }, 0);
    n = 1 / u;

    const d = document.querySelector('[data-ref="progress-bar"]');
    
 d.innerHTML = [
'<span data-ref="bar" class="juo-box__progress-bar-active-bar" style="width: 0%"></span>',
      '<span class="juo-box__progress-bar-marker" style="left: 10%">',
      '  <span class="juo-box__progress-bar-content" style="font-size: 17px;">',  // Add this style
      '    <span data-ref="icon" class="juo-box__progress-bar-icon"></span>',
      '    🚀',
      '  </span>',
      '</span>',
      '<span class="juo-box__progress-bar-marker" style="left: 18%">',   
      '  <span class="juo-box__progress-bar-content" style="font-size: 17px;">',  // And this one
      '    <span data-ref="icon" class="juo-box__progress-bar-icon"></span>',
      '    🎁',
      '  </span>',
      '</span>',


      
...e.map(function (a, index) {
        const position = (a.productsCount * n * 100);
        return `<span class="juo-box__progress-bar-marker" style="left: ${position}%">
            <span class="juo-box__progress-bar-content">
                <span data-ref="icon" class="juo-box__progress-bar-icon"></span>
                ${a.value}% off
            </span>
          </span>`;
      }),


      
...Object.keys([...Array(u + 1)]).map(function (a) {
        return `<span
          data-ref="step"
          class="juo-box__progress-bar-step ${e.findIndex(function (r) {
          return r.productsCount == a;
        }) !== -1 || a == 1 || a == 2 ? "juo-box__progress-bar-step--threshold" : ""}"
          style="left: ${a * n * 100}%"
        ></span>`;
      })


      
    ].join("");
  }

  function i(e, u) {
    const d = document.querySelector('[data-ref="progress-bar"]'),
      a = d.querySelectorAll('[data-ref="step"]');

    d.querySelector('[data-ref="bar"]').style.width = Math.max(0, Math.min(1, e * n)) * 100 + "%";

    a.forEach(function (l, y) {
      l.classList[y - 1 < e ? "add" : "remove"]("active");
    });

    const r = d.querySelectorAll('[data-ref="icon"]');
    d.querySelectorAll(".juo-box__progress-bar-marker");

    const s = u
      .sort((l, y) => l.productsCount - y.productsCount)
      .map(function (l, y) {
        const h = Object.assign({}, l);
        h.element = r[y];
        h.tierReached = e >= l.productsCount;
        return h;
      });

    s.forEach(function (l) {
      l.element.parentElement.classList[l.productsCount <= e ? "add" : "remove"]("active");
    });

    // Toggle emoji marker dots based on bar position, not tier threshold
    var barPercent = Math.max(0, Math.min(1, e * n)) * 100;
    d.querySelectorAll('.juo-box__progress-bar-marker').forEach(function (marker) {
      var markerLeft = parseFloat(marker.style.left);
      if (!isNaN(markerLeft)) {
        marker.classList[barPercent >= markerLeft ? "add" : "remove"]("marker-active");
      }
    });


    
const v = s.find(function (l) {
      return l.tierReached === false;
    });
const m = document.querySelector(".juo-box__tiers-description--initial");
const b = document.querySelector(".juo-box__tiers-description--completed");
const f = document.querySelector(".juo-box__tiers-description--first-item");
const second = document.querySelector(".juo-box__tiers-description--second-item");


    
    const zero = document.querySelector(".juo-box__tiers-description--zero-items");
const fourToSeven = document.querySelector(".juo-box__tiers-description--four-to-seven-items");
// Check AB test variant
const testVariant = sessionStorage.getItem('juo_ab_test_variant');
const is3ItemTest = testVariant === '3item';
const is2ItemTest = testVariant === '2item';
const minItems = is2ItemTest ? 2 : (is3ItemTest ? 3 : 4);

const zero3Item = document.querySelector(".juo-box__tiers-description--zero-items-3item");
const first3Item = document.querySelector(".juo-box__tiers-description--first-item-3item");
const completed3Item = document.querySelector(".juo-box__tiers-description--completed-3item");
const zero2Item = document.querySelector(".juo-box__tiers-description--zero-items-2item");
const first2Item = document.querySelector(".juo-box__tiers-description--first-item-2item");
const completed2Item = document.querySelector(".juo-box__tiers-description--completed-2item");

const elements = [m, b, f, second, fourToSeven, zero];
elements.forEach(el => {
    if(el) el.style.display = "none";
});

// Hide all variant elements by default
const elements3Item = [zero3Item, first3Item, completed3Item];
const elements2Item = [zero2Item, first2Item, completed2Item];
elements3Item.forEach(el => {
    if(el) el.style.display = "none";
});
elements2Item.forEach(el => {
    if(el) el.style.display = "none";
});

if (is2ItemTest) {
    // 2-ITEM TEST LOGIC
    if (e === 0 && zero2Item) {
        zero2Item.style.display = "block";
    } else if (e === 1 && first2Item) {
        first2Item.style.display = "block";
    } else if (e >= 2 && completed2Item) {
        completed2Item.style.display = "block";
    }
} else if (is3ItemTest) {
    // 3-ITEM TEST LOGIC
    if (e === 0 && zero3Item) {
        zero3Item.style.display = "block";
    } else if (e === 1 && first3Item) {
        first3Item.style.display = "block";
    } else if (e === 2 && first3Item) {
        first3Item.style.display = "block";
    } else if (e >= 3 && completed3Item) {
        completed3Item.style.display = "block";
    }
} else {
    // ORIGINAL 4-ITEM LOGIC
    if (e === 0 && zero) {
        zero.style.display = "block";
    } else if (e === 1 && f) {
        f.style.display = "block";
    } else if (e === 2 && second) {
        second.style.display = "block";
    } else if (e >= minItems && e < 8 && fourToSeven) {
        fourToSeven.style.display = "block";
        // Update countdown for minItems-7 items (counting to 8)
        const memberLeft = fourToSeven.querySelector(".member-version .juo-box__tiers-description--left");
        const nonMemberLeft = fourToSeven.querySelector(".non-member-version .juo-box__tiers-description--left");
        
        if (memberLeft) memberLeft.textContent = 8 - e;
        if (nonMemberLeft) nonMemberLeft.textContent = 8 - e;
    } else if (e >= u.at(-1).productsCount && b) {
        b.style.display = "block";
    } else if (m) {
        m.style.display = "block";
        if (v != null) {
            // Update both member and non-member countdown elements
            const memberLeft = m.querySelector(".member-version .juo-box__tiers-description--left");
            const nonMemberLeft = m.querySelector(".non-member-version .juo-box__tiers-description--left");
            const memberDiscount = m.querySelector(".member-version .juo-box__tiers-description--discount");
            const nonMemberDiscount = m.querySelector(".non-member-version .juo-box__tiers-description--discount");
            
            if (memberLeft) memberLeft.textContent = v.productsCount - e;
            if (nonMemberLeft) nonMemberLeft.textContent = v.productsCount - e;
            if (memberDiscount) memberDiscount.textContent = v.value;
            if (nonMemberDiscount) nonMemberDiscount.textContent = v.value;
        }
    }
}

    
    
  }

  document.addEventListener("juo-box:init-progress-bar", (e) => {
    c(e.detail.tiers);
  });

  document.addEventListener("juo-box:update-progress-bar", (e) => {
    i(e.detail.totalQty, e.detail.tiers);
  });
})();

// CRITICAL: Listen for cart drawer close to sync builder with cart state
document.addEventListener('DOMContentLoaded', function() {
  // INITIAL CART CHECK: Set cart count on page load (low risk, one-time only)
  if (window.location.pathname.includes('build-a-box')) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const cartBoxItems = cart.items.filter(item => {
          return item.sku && item.sku.includes('-bab');
        });
        const cartCount = cartBoxItems.reduce((sum, item) => sum + item.quantity, 0);
        
        // Store initial cart count
        window.buildABoxCartCount = cartCount;
        
        // Check if max-quantity-limited products are in cart and disable them
        const productsInCart = checkMaxQuantityProductsInCart(cart.items);
        window.limitedProductInCart = productsInCart; // Store object with all limited products
        
        // Disable each product that's in cart
        Object.keys(productsInCart).forEach(productId => {
          const productElement = document.querySelector(`#product-${productId}`);
          if (productElement) {
            productElement.style.opacity = '0.5';
            productElement.style.pointerEvents = 'none';
            const addBtn = productElement.querySelector('.juo-box__add-to-box-btn');
            if (addBtn) addBtn.disabled = true;
          }
        });
        
        // Simple: Just store the cart count (button will update when user interacts)
      })
      .catch(error => {
        console.log('Initial cart check failed:', error);
        window.buildABoxCartCount = 0;
      });
  }

  // SIMPLE: No complex cart close detection needed
  // Button updates automatically when user interacts with builder
});

function S(n, c) {
  typeof n == "string" && (n = n.replace(".", ""));
  let i = "";
  const e = /\{\{\s*(\w+)\s*\}\}/,
    u = c || "${{amount}}";

  function d(r, s) {
    return typeof r > "u" ? s : r;
  }

  function a(r, s, v, m) {
    if (((s = d(s, 2)), (v = d(v, ",")), (m = d(m, ".")), isNaN(r) || r == null)) return 0;
    r = (r / 100).toFixed(s);
    const b = r.split("."),
      l = b[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + v),
      y = b[1] ? m + b[1] : "";
    return l + y;
  }

  switch (u.match(e)[1]) {
    case "amount":
      i = a(n, 2);
      break;
    case "amount_no_decimals":
      i = a(n, 0);
      break;
    case "amount_with_comma_separator":
      i = a(n, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = a(n, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      i = a(n, 2, "'", ".");
      break;
  }

  return u.replace(e, i);
}

const w = { wrapper: "#juo-box-product-details-wrapper", gallery: ".swiper-wrapper" };

function j(n, c, i) {
  const e = S(n.price, i),
    [u, d] = c.id.split("-");
    
  // Calculate parentId for Fera widgets
  let parentId = d; // fallback
  const productElement = document.querySelector("#product-" + d);
  if (productElement && productElement.dataset.fruitNames) {
    try {
      const fruitNamesArray = JSON.parse(productElement.dataset.fruitNames);
      if (Array.isArray(fruitNamesArray) && fruitNamesArray.length > 0) {
        parentId = fruitNamesArray[0];
      }
    } catch (e) {
      console.log('Could not parse fruit names:', e);
    }
  }
    
  const a = `
  <div id="juo-box-product-details-wrapper" class="juo-build-a-box juo-reset">
<div id="juo-box-product-details" class="box-builder__products-list" data-box-item data-variant-id="${n.id}">
<!-- Product sticker removed temporarily
<div class="product-sticker">
  <h4 class="product-title">${c.querySelector("h3").innerText}</h4>
  <span class="product-price">${e}</span>
</div>
-->
      <button class="product-details-btn-close" type="button">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.25 3.90625L1.69531 0.351562C1.61328 0.296875 1.53125 0.269531 1.44922 0.269531C1.33984 0.269531 1.28516 0.296875 1.23047 0.351562L0.601562 0.980469C0.546875 1.03516 0.519531 1.11719 0.519531 1.19922C0.519531 1.30859 0.546875 1.39062 0.601562 1.44531L4.15625 5L0.601562 8.55469C0.546875 8.63672 0.519531 8.71875 0.519531 8.80078C0.519531 8.91016 0.546875 8.96484 0.601562 9.01953L1.23047 9.64844C1.28516 9.70312 1.33984 9.73047 1.44922 9.73047C1.53125 9.73047 1.61328 9.70312 1.69531 9.64844L5.25 6.09375L8.80469 9.64844C8.85938 9.70312 8.94141 9.73047 9.05078 9.73047C9.13281 9.73047 9.21484 9.70312 9.26953 9.64844L9.89844 9.01953C9.95312 8.96484 9.98047 8.91016 9.98047 8.80078C9.98047 8.71875 9.95312 8.63672 9.89844 8.55469L6.34375 5L9.89844 1.44531C9.95313 1.39062 9.98047 1.30859 9.98047 1.19922C9.98047 1.11719 9.95313 1.03516 9.89844 0.980469L9.26953 0.351562C9.21484 0.296875 9.13281 0.269531 9.05078 0.269531C8.94141 0.269531 8.85938 0.296875 8.80469 0.351562L5.25 3.90625Z" fill="black"></path>
        </svg>
      </button>
<div class="product-scrollable-content">
<div class="product-gallery" ontouchstart="this.touchstartX = event.changedTouches[0].screenX;" ontouchend="
  const diffX = this.touchstartX - event.changedTouches[0].screenX;
  const slides = this.querySelectorAll('.slide');
  const dots = this.querySelectorAll('.dot');
  const thumbnails = this.closest('.product-scrollable-content').querySelectorAll('.modal-thumbnail-button');
  let currentIndex = Array.from(slides).findIndex(slide => slide.classList.contains('active'));
  
  if (Math.abs(diffX) > 50) {
    if (diffX > 0 && currentIndex < slides.length - 1) currentIndex++;
    else if (diffX < 0 && currentIndex > 0) currentIndex--;
    
    slides.forEach(s => s.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));
    thumbnails.forEach(t => t.classList.remove('active'));
    slides[currentIndex].classList.add('active');
    dots[currentIndex].classList.add('active');
    if (thumbnails[currentIndex]) thumbnails[currentIndex].classList.add('active');
    
    // Hide badge on 2nd photo (index 1), show on all others
    const badge = this.querySelector('.product-badge');
    if (badge) {
      badge.style.display = currentIndex === 1 ? 'none' : 'block';
    }
  }
">
  <div class="product-badge">${HASH_ONLY_CONFIG[d]?.badgeText || 'Get 50% Off'}</div>
  ${(() => {
    const mediaElement = c.querySelector("#product-media-" + d);
    if (!mediaElement) return '<div class="slide active"><div style="padding: 40px; text-align: center;">No media available</div></div>';
    
    // Extract both images and videos
    const images = mediaElement.innerHTML.match(/<img[^>]+>/g) || [];
    const videos = mediaElement.innerHTML.match(/<video[^>]*>[\s\S]*?<\/video>/gi) || [];
    const iframes = mediaElement.innerHTML.match(/<iframe[^>]*>[\s\S]*?<\/iframe>/gi) || [];
    
    const allMedia = [...images, ...videos, ...iframes];
    if (allMedia.length === 0) return '<div class="slide active"><div style="padding: 40px; text-align: center;">No media available</div></div>';
    
    return allMedia.map((media, i) => `
      <div class="slide ${i === 0 ? 'active' : ''}">${media}</div>
    `).join('');
  })()}
  <div class="dots">
    ${(() => {
      const mediaElement = c.querySelector("#product-media-" + d);
      if (!mediaElement) return '';
      
      // Extract both images and videos for dots
      const images = mediaElement.innerHTML.match(/<img[^>]+>/g) || [];
      const videos = mediaElement.innerHTML.match(/<video[^>]*>[\s\S]*?<\/video>/gi) || [];
      const iframes = mediaElement.innerHTML.match(/<iframe[^>]*>[\s\S]*?<\/iframe>/gi) || [];
      
      const allMedia = [...images, ...videos, ...iframes];
      if (allMedia.length === 0) return '';
      
      return allMedia.map((_, i) => `
        <button class="dot ${i === 0 ? 'active' : ''}" onclick="
          const gallery = this.closest('.product-gallery');
          const thumbnails = this.closest('.product-scrollable-content').querySelectorAll('.modal-thumbnail-button');
          gallery.querySelectorAll('.slide').forEach(s => s.classList.remove('active'));
          gallery.querySelectorAll('.slide')[` + i + `].classList.add('active');
          this.closest('.dots').querySelectorAll('.dot').forEach(d => d.classList.remove('active'));
          thumbnails.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
          if (thumbnails[` + i + `]) thumbnails[` + i + `].classList.add('active');
          
          // Hide badge on 2nd photo (index 1), show on all others
          const badge = gallery.querySelector('.product-badge');
          if (badge) {
            badge.style.display = ` + i + ` === 1 ? 'none' : 'block';
          }
        "></button>
      `).join('');
    })()}
  </div>
</div>
<div class="modal-thumbnail-slider">
  <div class="modal-thumbnail-list">
    ${(() => {
      const mediaElement = c.querySelector("#product-media-" + d);
      if (!mediaElement) return '';
      
      // Extract both images and videos for thumbnails
      const images = mediaElement.innerHTML.match(/<img[^>]+>/g) || [];
      const videos = mediaElement.innerHTML.match(/<video[^>]*>[\s\S]*?<\/video>/gi) || [];
      const iframes = mediaElement.innerHTML.match(/<iframe[^>]*>[\s\S]*?<\/iframe>/gi) || [];
      
      const allMedia = [...images, ...videos, ...iframes];
      if (allMedia.length === 0) return '';
      
      return allMedia.map((media, i) => {
        let thumbnailSrc = '';
        let altText = `Media ${i + 1}`;
        
        if (media.includes('<img')) {
          // It's an image
          thumbnailSrc = media.match(/src="([^"]+)"/)?.[1] || '';
          altText = `Product thumbnail ${i + 1}`;
        } else if (media.includes('<video')) {
          // It's a video - try to get poster image or first frame
          const posterMatch = media.match(/poster="([^"]+)"/);
          if (posterMatch) {
            thumbnailSrc = posterMatch[1];
          } else {
            // Use a video play icon or placeholder
            thumbnailSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8cGF0aCBkPSJNMjMgMTlWNDFMMzggMzBMMjMgMTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K';
          }
          altText = `Video thumbnail ${i + 1}`;
        } else if (media.includes('<iframe')) {
          // It's an iframe (YouTube/Vimeo) - use a video placeholder
          thumbnailSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjRkYwMDAwIiBmaWxsLW9wYWNpdHk9IjAuOCIvPgo8cGF0aCBkPSJNMjMgMTlWNDFMMzggMzBMMjMgMTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K';
          altText = `Video thumbnail ${i + 1}`;
        }
        
        return `
          <div class="modal-thumbnail-item">
            <button class="modal-thumbnail-button ${i === 0 ? 'active' : ''}" onclick="
              const gallery = this.closest('.product-scrollable-content').querySelector('.product-gallery');
              const slides = gallery.querySelectorAll('.slide');
              const dots = gallery.querySelectorAll('.dot');
              const thumbnails = this.closest('.modal-thumbnail-list').querySelectorAll('.modal-thumbnail-button');
              
              slides.forEach(s => s.classList.remove('active'));
              dots.forEach(d => d.classList.remove('active'));
              thumbnails.forEach(t => t.classList.remove('active'));
              
              slides[` + i + `].classList.add('active');
              dots[` + i + `].classList.add('active');
              this.classList.add('active');
              
              // Hide badge on 2nd photo (index 1), show on all others
              const badge = gallery.querySelector('.product-badge');
              if (badge) {
                badge.style.display = ` + i + ` === 1 ? 'none' : 'block';
              }
            ">
              <img src="${thumbnailSrc}" alt="${altText}" loading="lazy">
            </button>
          </div>
        `;
      }).join('');
    })()}
  </div>
</div>
<div class="product-meta">
  <!-- Fera Rating Stars - ABOVE the title -->
  <div class="product-rating">
        <div data-fera-widget="product_detail_rating" 
             data-fera-id="fwid_2iAM7cY" 
             data-product-id="${parentId}"
             style="margin-bottom: 0px;">
    </div>
  </div>
  
  <div class="product-data">
    <h4>${c.querySelector("h3").innerText}</h4>
    <span class="product-price">
      <span class="product-price-original">$${(() => {
        const productId = c.id.split('-')[1];
        const customPrice = HASH_ONLY_CONFIG[productId]?.compareAtPrice;
        return customPrice ? Math.round(customPrice/100) : Math.round(n.price/100);
      })()}</span>
      <span class="product-price-discounted">$${Math.round((n.price/100) * (() => {
        const memberSelected = document.querySelector('input[name="pricing-type"][value="member"]')?.checked;
        if (memberSelected) return 0.5;
        
        let itemCount = 0;
        document.querySelectorAll('.juo-box__product-qty-input').forEach(input => {
          itemCount += parseInt(input.value || 0);
        });
        
        return itemCount >= 5 ? 0.5 : 0.65;
      })())}</span>
    </span>
  </div>
  <div class="row">
    <div class="product-description">${c.querySelector("#product-description-" + d).innerHTML}</div>
  </div>
  
  <!-- Add Item Button (in-flow version) -->
  <div class="product-add-to-box-inline-wrapper">
    <button
      type="button"
      class="product-add-to-box-inline ${(() => {
        const config = HASH_ONLY_CONFIG[d];
        if (config?.dontCountTowardsMin && config?.maxQuantity === 1) {
          const variantRow = document.querySelector('[data-variant="' + n.id + '"]');
          const qtyInput = variantRow?.querySelector('.juo-box__product-qty-input');
          return (qtyInput && parseInt(qtyInput.value) > 0) ? 'gift-added' : '';
        }
        return '';
      })()}"
      data-variant-id="${n.id}"
      data-add-to-box
    >
      <span>${(() => {
        const config = HASH_ONLY_CONFIG[d];
        if (config?.dontCountTowardsMin && config?.maxQuantity === 1) {
          const variantRow = document.querySelector('[data-variant="' + n.id + '"]');
          const qtyInput = variantRow?.querySelector('.juo-box__product-qty-input');
          return (qtyInput && parseInt(qtyInput.value) > 0) ? 'Added' : 'Add to Box';
        }
        return 'Add to Box';
      })()}</span>
    </button>
  </div>
  
  <!-- Guarantee and Shipping Info -->
  <div class="modal-guarantee-shipping-info">
    <div>
      <span class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          <polyline points="8 11.8 11 14.8 16 9.8"></polyline>
        </svg>
      </span>
      <span>Money Back Guarantee</span>
    </div>
    <div>
      <span class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"></path>
          <path d="M3 9V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2"></path>
          <path d="M16 13h0"></path>
          <path d="M8 13h0"></path>
        </svg>
      </span>
      <span id="shipping-date-text-${n.id}" class="shipping-date-text">${(() => {
        const now = new Date();
        const utcTime = now.getTime();
        const pstOffset = -8 * 60 * 60 * 1000;
        const currentTimePST = new Date(utcTime + pstOffset);
        const currentDay = currentTimePST.getDay();
        const currentHour = currentTimePST.getHours();
        const cutoffHour = 19;
        const thursdayTransitionHour = 3;
        let daysToAdd = 0;

        if (currentDay === 4 && currentHour < thursdayTransitionHour) {
          daysToAdd = 2;
        } else if (currentHour < cutoffHour) {
          if (currentDay === 0) daysToAdd = 2;
          else if (currentDay === 1) daysToAdd = 2;
          else if (currentDay === 2) daysToAdd = 2;
          else if (currentDay === 3) daysToAdd = 2;
          else if (currentDay === 4) daysToAdd = 5;
          else if (currentDay === 5) daysToAdd = 4;
          else if (currentDay === 6) daysToAdd = 3;
        } else {
          if (currentDay === 0) daysToAdd = 3;
          else if (currentDay === 1) daysToAdd = 3;
          else if (currentDay === 2) daysToAdd = 3;
          else if (currentDay === 3) daysToAdd = 6;
          else if (currentDay === 4) daysToAdd = 5;
          else if (currentDay === 5) daysToAdd = 4;
          else if (currentDay === 6) daysToAdd = 3;
        }

        let deliveryDate = new Date(currentTimePST);
        deliveryDate.setDate(currentTimePST.getDate() + daysToAdd);
        const month = (deliveryDate.getMonth() + 1).toString().padStart(2, '0');
        const day = deliveryDate.getDate().toString().padStart(2, '0');
        return `Delivery By ${month}/${day}`;
      })()}</span>
    </div>
  </div>
  
  <!-- Tolstoy removed from modal -->
  
  <!-- Product Attribute Blocks (Mobile Only) -->
  ${(() => {
    const tastes = c.querySelector("#product-tastes-" + d)?.innerHTML || "";
    const feels = c.querySelector("#product-feels-" + d)?.innerHTML || "";
    const ripeness = c.querySelector("#product-ripeness-" + d)?.innerHTML || "";
    const handle = c.querySelector("h3")?.innerText?.toLowerCase().replace(/\s+/g, '-') || "";
    
    let attributesHTML = '';
    
    if (tastes || feels || ripeness) {
      attributesHTML = '<div class="product-attributes-wrapper">';
      
      // Tastes Block
      if (tastes) {
        attributesHTML += `
          <div class="product-attribute-block">
            <div class="product-attribute-block__icon">
              <img src="https://cdn.shopify.com/s/files/1/0615/2185/4624/files/tastes_like_icon_v2.png?v=1743785183"
                   alt="Taste icon" width="45" height="45" loading="lazy"
                   class="product-attribute-block__icon-img">
            </div>
            <div class="product-attribute-block__content">
              <h4 class="product-attribute-block__title">
                ${handle.includes('gift-basket') ? 'How It Delights' : 'How It Tastes'}
              </h4>
              <div class="product-attribute-block__description">${tastes}</div>
            </div>
          </div>`;
      }
      
      // Feels Block
      if (feels) {
        attributesHTML += `
          <div class="product-attribute-block">
            <div class="product-attribute-block__icon">
              <img src="https://cdn.shopify.com/s/files/1/0615/2185/4624/files/feels_like_icon_v2.png?v=1743785183"
                   alt="Feel icon" width="45" height="45" loading="lazy"
                   class="product-attribute-block__icon-img">
            </div>
            <div class="product-attribute-block__content">
              <h4 class="product-attribute-block__title">
                ${handle.includes('gift-basket') ? "What's Inside" : 'How It Feels'}
              </h4>
              <div class="product-attribute-block__description">${feels}</div>
            </div>
          </div>`;
      }
      
      // Ripeness Block
      if (ripeness) {
        attributesHTML += `
          <div class="product-attribute-block">
            <div class="product-attribute-block__icon">
              <img src="https://cdn.shopify.com/s/files/1/0615/2185/4624/files/ripeness_icon_v2.png?v=1743785183"
                   alt="Ripeness icon" width="45" height="45" loading="lazy"
                   class="product-attribute-block__icon-img">
            </div>
            <div class="product-attribute-block__content">
              <h4 class="product-attribute-block__title">
                ${handle.includes('gift-basket') ? 'Gifting That Lasts' : 'Ripeness'}
              </h4>
              <div class="product-attribute-block__description">${ripeness}</div>
            </div>
          </div>`;
      }
      
      attributesHTML += '</div>';
    }
    
    return attributesHTML;
  })()}
  
  <!-- Nested Collapsible Section -->
  <div class="modal-accordion-wrapper">
    ${(() => {
      // Get FAQ metafield content from the template elements
      const faqHeaderElement = c.querySelector("#product-faq-header-" + d);
      const faqBodyElement = c.querySelector("#product-faq-body-" + d);
      
      // Extract content - these come from product.metafields.custom.faq.value
      let faqHeader = faqHeaderElement?.innerHTML?.trim() || "";
      let faqBody = faqBodyElement?.innerHTML?.trim() || "";
      
      // The metafield_tag filter in Liquid should already render the content properly
      // Just use it as-is, no complex parsing needed
      
      // faqHeader stays as text (no HTML expected)
      // faqBody is already HTML from metafield_tag filter
      
      const productTitle = c.querySelector("h3")?.innerText || "Product";
      
      // First collapsible: Product Info (uses FAQ metafield if available)
      let accordionHTML = '';
      if (faqHeader && faqBody) {
        accordionHTML += `
          <details class="modal-accordion-item">
            <summary class="modal-accordion-summary">
              <h3 class="modal-accordion-title">
                ${faqHeader}
              </h3>
              <span class="modal-accordion-icon">+</span>
            </summary>
            <div class="modal-accordion-content">
              ${faqBody}
            </div>
          </details>`;
      } else {
        // Fallback if FAQ metafields are not available
        accordionHTML += `
          <details class="modal-accordion-item">
            <summary class="modal-accordion-summary">
              <h3 class="modal-accordion-title">
                ${productTitle} Info
              </h3>
              <span class="modal-accordion-icon">+</span>
            </summary>
            <div class="modal-accordion-content">
              ${c.querySelector("#product-description-" + d)?.innerHTML || ""}
            </div>
          </details>`;
      }
      
      // Additional static collapsibles
      accordionHTML += `
        <details class="modal-accordion-item">
          <summary class="modal-accordion-summary">
            <h3 class="modal-accordion-title">
              Our Farm & Fruit
            </h3>
            <span class="modal-accordion-icon">+</span>
          </summary>
          <div class="modal-accordion-content">
            <p>🧑‍🌾 Know Your Farm: Good Hill Farms is a friends and family owned subtropical farm and nursery.Nestled in coastal hills above sunny San Diego, we farm a beautiful 20 acres in Fallbrook, California.<br><br>🥭 Know Your Fruit: We work hard to produce and source the most delicious fruit on earth. We farm sustainably and pesticide-free on our 20 acres.We also work with partners who share our passion in delivering the perfect fruit. This lets us share more deliciousness like mangosteen, which can't be grown in the US!<br><br>🌏 Our Simple Mission: Spread the joy and benefits of exotic fruit to people everywhere.Shockingly tasty and healthy?! What's not to love about exotic fruit 😍</p>
          </div>
        </details>
        
        <details class="modal-accordion-item">
          <summary class="modal-accordion-summary">
            <h3 class="modal-accordion-title">
              FAQs
            </h3>
            <span class="modal-accordion-icon">+</span>
          </summary>
          <div class="modal-accordion-content">
            <p>🏆 Fruit Quality: Every harvest is hand sorted and tested to meet our industry-leading standards of taste, size and ripeness. Our fruit quality is second-to-none!<br><br>🛍️ Gifting: Give the joy of delicious exotic fruit! Choose 'Send as a gift' to add your gift info, custom note and schedule delivery. Your gift will arrive looking and tasting fantastic.<br><br>⛈️ If a fruit can't ship: Farming can be impacted by severe weather. We share realtime farm and fruit statuses so you'll know exactly when / if any fruit is delayed by Mother Nature.</p>
          </div>
        </details>
        
        <details class="modal-accordion-item">
          <summary class="modal-accordion-summary">
            <h3 class="modal-accordion-title">
              Money Back Guarantee
            </h3>
            <span class="modal-accordion-icon">+</span>
          </summary>
          <div class="modal-accordion-content">
            <p>If you're not 100% satisfied, we'll replace or refund your order, no questions asked.<br><br>We're confident that perfect fruit you'll love will arrive on your doorstep.</p>
          </div>
        </details>
        
        <details class="modal-accordion-item">
          <summary class="modal-accordion-summary">
            <h3 class="modal-accordion-title">
              Shipping
            </h3>
            <span class="modal-accordion-icon">+</span>
          </summary>
          <div class="modal-accordion-content">
            <p>We ship Monday through Thursday on a 'first-come' basis, working hard to ship all orders of in-season fruit each week.<br><br>Our standard shipping has fast 1-2 day transit times via insured express shipping.<br><br>Our summer packaging includes liners and coolant to ensure perfect fruit arrives, no matter the weather.</p>
          </div>
        </details>
      `;
      
      return accordionHTML;
    })()}
  </div>
  
  <!-- Reviews Section -->
  <div class="modal-reviews-section">
    <div class="modal-reviews-container">
      <div data-fera-widget="product_reviews" data-product-id="${parentId}"></div>
      </div>
    </div>
  </div>
  
  <!-- Fera Styling for Modal - Matching main-product.liquid exactly -->
  <style>
    /* Widget container */
    .product-rating .fera-widget.fera-productDetailRating-widget {
      font-size: 14px;
      line-height: 1.42;
      color: #000000;
    }
    
    /* Star container and sizing */
    .product-rating .fera-averageRating-average-stars,
    .product-rating .fera-stars,
    .product-rating .fera-stars-rating,
    .product-rating .fera-stars-bg {
      --size: 12px !important;
      font-size: 12px !important;
      white-space: nowrap !important;
      display: inline-block !important;
    }
    
    /* Fix star alignment in product rating widget */
    .product-rating .fera-averageRating {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
    }
    
    .product-rating .fera-averageRating-average {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
    }
    
    /* Order: Stars first, then average number */
    .product-rating .fera-averageRating-average-stars {
      order: 1 !important;
    }
    
    .product-rating .fera-averageRating-average-number {
      order: 2 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    /* Fix the stars container alignment */
    .product-rating .fera-averageRating-average-stars {
      position: relative !important;
      display: inline-block !important;
      vertical-align: middle !important;
      height: 14px !important;
      line-height: 1 !important;
    }
    
    .product-rating .fera-stars {
      position: relative !important;
      display: inline-block !important;
      height: 14px !important;
      line-height: 14px !important;
      vertical-align: middle !important;
    }
    
    /* Ensure the background stars are properly positioned */
    .product-rating .fera-stars-bg {
      display: inline-block !important;
      line-height: 14px !important;
      height: 14px !important;
      vertical-align: top !important;
    }
    
    .product-rating .fera-stars-bg b {
      font-size: 12px !important;
      line-height: 14px !important;
      vertical-align: top !important;
    }
    
    /* Fix the absolute positioned rating stars */
    .product-rating .fera-stars-rating {
      line-height: 14px !important;
      height: 14px !important;
    }
    
    .product-rating .fera-stars-rating b {
      font-size: 12px !important;
      line-height: 14px !important;
      vertical-align: top !important;
    }
    
    .product-rating .fera-stars-rating b,
    .product-rating .fera-stars-bg b {
      font-size: 12px !important;
    }
    
    /* Star colors using background-color method */
    .product-rating .fera-widget[data-fera-id="fwid_2iAM7cY"] .fera-stars-rating {
      width: 12px; /* This gets overridden by inline style to ~121px */
    }
    
    .product-rating .fera-widget[data-fera-id="fwid_2iAM7cY"] .fera-stars-rating b {
      background-color: #000000;
      color: transparent;
    }
    
    /* Rating number and count styling */
    .product-rating .fera-averageRating-average-number,
    .product-rating .fera-averageRating-count-total {
      color: #000000;
      font-size: 14px;
      font-weight: 500;
      margin-left: 0.25rem;
      margin-right: 6px;
      border-right: 1px solid #e5e7eb;
      padding-right: 0.5rem;
    }
    
    /* Container layout */
    .product-rating .fera-averageRating {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      min-height: 1rem;
    }
    
    /* Reorder elements */
    .product-rating .fera-stars-rating {
      order: 1;
    }
    
    .product-rating .fera-averageRating-average-number {
      order: 2;
      margin-left: 0;
      margin-right: 0;
      border-right: none;
      padding-right: 0;
    }
    
    .product-rating .fera-averageRating-count-total {
      order: 3;
      font-size: 13px;
      color: #6b7280;
      border-right: none;
      padding-right: 0;
      margin-right: 0;
      margin-left: 0;
      font-weight: 500;
      position: relative;
    }
    
    /* Add separator after rating number */
    .product-rating .fera-averageRating-average-number::after {
      content: "|";
      color: #e5e7eb;
      margin: 0 8px;
      font-size: 12px;
      text-decoration: none;
    }
    
    /* Add "Reviews" text after count */
    .product-rating .fera-averageRating-count-total::after {
      content: " Reviews";
      color: #6b7280;
      font-size: 12px;
      font-weight: 500;
      text-decoration: underline;
      text-underline-offset: 3px;
    }
    
    /* Underline styling for count */
    .product-rating .fera-widget .fera-averageRating .fera-averageRating-count .fera-averageRating-count-total {
      text-decoration-line: underline !important;
      text-underline-offset: 3px !important;
      color: #6b7280 !important;
      font-size: 13px !important;
      line-height: 1.42 !important;
    }
    
    /* Remove parentheses */
    .product-rating .fera-averageRating-count-str::before,
    .product-rating .fera-averageRating-count-str::after {
      content: none !important;
    }
    
    /* Remove any default text decorations */
    .product-rating .fera-averageRating-count-total * {
      text-decoration: none !important;
    }
    
    /* Modal Reviews Section Styling */
    .modal-reviews-section {
      padding: 0 !important;
    }
    
    /* Modal Reviews Container Styling */
    .modal-reviews-container {
      width: 100%;
      --star-color: #ffc107;
      --star-bg-color: transparent;
    }

    /* Header summary stars - match product-rating approach */
    .modal-reviews-container .fera-averageRating-average-stars,
    .modal-reviews-container .fera-reviews-header .fera-stars,
    .modal-reviews-container .fera-reviews-header .fera-stars-rating,
    .modal-reviews-container .fera-reviews-header .fera-stars-bg {
      --size: 12px !important;
      font-size: 12px !important;
      white-space: nowrap !important;
      display: inline-block !important;
    }

    .modal-reviews-container .fera-reviews-header .fera-stars {
      position: relative !important;
      height: 14px !important;
      line-height: 14px !important;
      vertical-align: middle !important;
    }

    .modal-reviews-container .fera-reviews-header .fera-stars-bg {
      display: inline-block !important;
      line-height: 14px !important;
      height: 14px !important;
      vertical-align: top !important;
    }

    .modal-reviews-container .fera-reviews-header .fera-stars-rating {
      line-height: 14px !important;
      height: 14px !important;
    }

    .modal-reviews-container .fera-reviews-header .fera-stars-bg b,
    .modal-reviews-container .fera-reviews-header .fera-stars-rating b {
      font-size: 12px !important;
      line-height: 14px !important;
      vertical-align: top !important;
    }

    .modal-reviews-container .fera-reviews-header .fera-stars-rating b {
      background-color: #ffc107;
      color: transparent;
    }

    /* Modal Tolstoy Widget Section Styling */
    .modal-tolstoy-section {
      width: 100%;
      padding: 0 !important;
      margin: 30px 0 0 0 !important;
    }
    
    /* ============================================================================ */
    /* LOCKED PRODUCT STYLES */
    /* ============================================================================ */
    
    /* Lock overlay for hash products - just grey out the card */
    .hash-product-locked {
      position: relative;
      opacity: 0.5;
      filter: grayscale(50%);
    }
    
    /* Unlock animation */
    .hash-product-unlocking {
      animation: unlockFade 0.5s ease forwards;
    }
    
    @keyframes unlockFade {
      to {
        opacity: 1;
        filter: grayscale(0%);
      }
    }
    
    .hash-product-unlocked {
      opacity: 1;
      filter: grayscale(0%);
    }
    
    .modal-tolstoy-section .tolstoy-stories {
      width: 100%;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .modal-tolstoy-section .tolstoy-stories-main-container {
      margin: 0 !important;
      padding: 0 !important;
    }
    
    /* Force horizontal layout for Tolstoy videos */
    .modal-tolstoy-section .tolstoy-stories-main-container {
      width: 100% !important;
      height: auto !important;
      max-height: 200px !important;
    }
    
    .modal-tolstoy-section .tolstoy-stories-container {
      display: flex !important;
      flex-direction: row !important;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      gap: 8px !important;
      padding: 0 !important;
      height: auto !important;
    }
    
    .modal-tolstoy-section .tolstoy-stories-tiles-container {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      gap: 8px !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      padding: 0 !important;
      width: auto !important;
      height: auto !important;
    }
    
    .modal-tolstoy-section ._storiesVideoContainer_1v61q_12 {
      display: flex !important;
      flex-direction: row !important;
      gap: 8px !important;
      width: 100% !important;
    }
    
    .modal-tolstoy-section .tolstoy-stories-tile {
      flex: 0 0 auto !important;
      max-width: 112px !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .modal-tolstoy-section .tolstoy-stories-tile-name {
      margin: 0 !important;
      padding: 0 !important;
    }
    
    /* Hide navigation arrows in modal */
    .modal-tolstoy-section .tolstoy-stories-previous-button,
    .modal-tolstoy-section .tolstoy-stories-next-button {
      display: none !important;
    }
    
    @media (max-width: 768px) {
      .modal-tolstoy-section {
        margin: 20px 0 0 0 !important;
      }
    }
    
    .modal-reviews-container .fera-widget {
      margin: 0 !important;
      padding: 0 !important;
    }
    
    /* Remove padding from Fera elements */
    .modal-reviews-container .fera-reviews-body {
      padding: 0 !important;
      margin: 0 !important;
    }
    
    .modal-reviews-container .fera-reviews-header {
      padding: 0 !important;
      margin: 0 !important;
    }
    
    .modal-reviews-container .fera-reviews-body-top {
      padding: 0 !important;
      margin: 0 !important;
    }
    
    /* Mobile-specific styling for Fera reviews in modal */
    @media (max-width: 768px) {
      .modal-reviews-container {
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: hidden !important;
      }
      
      .modal-reviews-container .fera-widget {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
    
    @media (max-width: 640px) {
      .modal-reviews-section {
        padding: 0;
      }
    }
      
      /* Header styling */
      .modal-reviews-container .fera-reviews-header {
        padding: 0 !important;
        margin-bottom: 15px !important;
        width: 100% !important;
      }
      
      .modal-reviews-container .fera-reviews-header h1 {
        font-size: 18px !important;
        margin-bottom: 10px !important;
        color: #000 !important;
        width: 100% !important;
        font-weight: 600 !important;
      }
      
      /* Header summary styling */
      .modal-reviews-container .fera-reviews-header-summary {
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
        margin-bottom: 10px !important;
        flex-wrap: nowrap !important;
      }
      
      /* Fix Fera row/col layout */
      .modal-reviews-container .fera-reviews-header-row2 {
        display: flex !important;
        align-items: center !important;
        width: 100% !important;
      }
      
      .modal-reviews-container .fera-reviews-header-summary-container {
        display: flex !important;
        align-items: center !important;
        width: 100% !important;
        flex: 1 !important;
      }
      
      .modal-reviews-container .fera-reviews-header-summary {
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
        flex: 1 !important;
        margin-bottom: 0 !important;
      }
      
      /* Override Fera's grid system for rating */
      .modal-reviews-container .fera-reviews-header-summary-average-rating {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        flex-wrap: nowrap !important;
        white-space: nowrap !important;
      }

      /* Hide mobile-only review count */
      .modal-reviews-container .fera-averageRating-count-str--min.fera-visible-xs {
        display: none !important;
      }
      
      /* Make rating and count display in one line - following product rating pattern */
      .modal-reviews-container .fera-averageRating {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        flex-wrap: nowrap !important;
        white-space: nowrap !important;
        overflow: visible !important;
        min-width: 0 !important;
        justify-content: center !important;
      }
      
      .modal-reviews-container .fera-averageRating-average {
        display: flex !important;
        align-items: center !important;
        gap: 6px !important;
        flex-shrink: 0 !important;
      }
      
      /* Order: Stars first, then rating number, then count - matching top widget */
      .modal-reviews-container .fera-averageRating-average-stars {
        order: 1 !important;
        flex-shrink: 0 !important;
      }

      .modal-reviews-container .fera-averageRating-average-number {
        order: 2 !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .modal-reviews-container .fera-averageRating-count {
        order: 3 !important;
        flex-shrink: 0 !important;
        padding-left: 8px !important;
        border-left: 1px solid #d1d5db !important;
      }
      
      /* Always show rating number, even on extra small screens */
      .modal-reviews-container .fera-averageRating-average-number.fera-hidden-xxs {
        display: inline !important;
      }
      
      .modal-reviews-container .fera-averageRating-count {
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
        flex-shrink: 0 !important;
      }
      
      /* Ensure stars don't wrap */
      .modal-reviews-container .fera-averageRating-average-stars {
        flex-shrink: 0 !important;
      }
      
      /* Prevent text cutting */
      .modal-reviews-container .fera-averageRating-average-number,
      .modal-reviews-container .fera-averageRating-count-str,
      .modal-reviews-container .fera-averageRating-count-total {
        overflow: visible !important;
        white-space: nowrap !important;
        text-overflow: unset !important;
      }
      
      .modal-reviews-container .fera-averageRating-average-number {
        font-size: 14px !important;
        font-weight: 500 !important;
        color: #000 !important;
        margin-right: 8px !important;
      }
      
      .modal-reviews-container .fera-averageRating-count-str {
        font-size: 14px !important;
        color: #000 !important;
        text-decoration: none !important;
        font-weight: 400 !important;
      }
      
      /* Body styling */
      .modal-reviews-container .fera-reviews-body {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
      }
      
      .modal-reviews-container .fera-reviews-body-items {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
      }
      
      /* Individual review styling - Force spacing with maximum specificity */
      .modal-reviews-container .fera-review,
      .modal-reviews-container .fera-review.fera-review--for-product,
      .modal-reviews-container .fera-review.fera-row {
        padding: 24px 0 !important;
        border-bottom: 1px solid #e5e7eb !important;
        margin-bottom: 18px !important;
        margin-top: 18px !important;
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
      
      /* Force spacing on all review elements */
      .modal-reviews-container .fera-review[data-id] {
        margin-bottom: 18px !important;
        margin-top: 18px !important;
      }
      
      /* Override any inline styles that Fera might add */
      .modal-reviews-container .fera-review[style*="margin"] {
        margin-bottom: 18px !important;
        margin-top: 18px !important;
      }
      
      .modal-reviews-container .fera-review:last-child {
        border-bottom: none !important;
        padding-bottom: 0 !important;
      }
      
      .modal-reviews-container .fera-review-content-col {
        width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
        display: block !important;
      }
      
      /* Rating and date styling */
      .modal-reviews-container .fera-review-ratingAndDate {
        margin-bottom: 12px !important;
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        width: 100% !important;
        flex-wrap: nowrap !important;
        white-space: nowrap !important;
      }
      
      .modal-reviews-container .fera-review-ratingAndDate > div {
        display: inline-block !important;
        white-space: nowrap !important;
        flex-shrink: 0 !important;
      }
      
      /* Review star styling */
      .modal-reviews-container .fera-review-rating {
        display: inline-block !important;
        white-space: nowrap !important;
        flex-shrink: 0 !important;
      }
      
      .modal-reviews-container .fera-review-rating {
        --star-color: #ffc107;
        --star-bg-color: transparent;
      }
      
      .modal-reviews-container .fera-review-date-val {
        font-size: 13px !important;
        color: #6b7280 !important;
        white-space: nowrap !important;
      }
      
      .modal-reviews-container .fera-review-date {
        display: inline-block !important;
        white-space: nowrap !important;
        flex-shrink: 0 !important;
      }
      
      /* Force all Fera rating and date elements to be inline */
      .modal-reviews-container .fera-review-ratingAndDate .fera-review-rating,
      .modal-reviews-container .fera-review-ratingAndDate .fera-review-date {
        display: inline-block !important;
        vertical-align: middle !important;
        white-space: nowrap !important;
        margin-right: 8px !important;
        float: none !important;
        clear: none !important;
      }
      
      .modal-reviews-container .fera-review-ratingAndDate .fera-review-date {
        margin-right: 0 !important;
      }
      
      /* Override any Fera default styling that might be causing block behavior */
      .modal-reviews-container .fera-review-ratingAndDate > div[class*="fera-review-rating"],
      .modal-reviews-container .fera-review-ratingAndDate > div[class*="fera-review-date"] {
        display: inline-block !important;
        width: auto !important;
        float: none !important;
        clear: none !important;
        vertical-align: middle !important;
      }
      
      /* Ensure the container itself doesn't force block behavior */
      .modal-reviews-container .fera-review-ratingAndDate {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        gap: 8px !important;
        justify-content: flex-start !important;
        width: auto !important;
        max-width: none !important;
      }
      
      /* Override any Fera CSS that might be causing separation */
      .modal-reviews-container .fera-review-ratingAndDate[style*="justify-content"] {
        justify-content: flex-start !important;
      }
      
      /* Target the exact div structure that Fera generates */
      .modal-reviews-container .fera-review-ratingAndDate > div.fera-review-rating.fera-stars,
      .modal-reviews-container .fera-review-ratingAndDate > div.fera-review-date {
        display: inline-block !important;
        vertical-align: middle !important;
        white-space: nowrap !important;
        float: none !important;
        clear: none !important;
        width: auto !important;
        flex-shrink: 0 !important;
        line-height: 1 !important;
        height: auto !important;
      }
      
      /* Stars positioning - no negative margins */
      
      
      /* Force the container to use flexbox with space-between */
      .modal-reviews-container .fera-review-ratingAndDate {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        justify-content: space-between !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      
      /* Force inline layout for all child elements */
      .modal-reviews-container .fera-review-ratingAndDate * {
        display: inline-block !important;
        vertical-align: middle !important;
        white-space: nowrap !important;
      }
      
      /* Specific targeting for the rating and date divs */
      .modal-reviews-container .fera-review-ratingAndDate > div {
        display: inline-block !important;
        vertical-align: middle !important;
        margin-right: 8px !important;
        float: none !important;
        clear: none !important;
        width: auto !important;
        max-width: none !important;
      }
      
      .modal-reviews-container .fera-review-ratingAndDate > div:last-child {
        margin-right: 0 !important;
      }
      
      /* Review body styling */
      .modal-reviews-container .fera-review-body {
        font-size: 14px !important;
        line-height: 1.5 !important;
        margin-bottom: 16px !important;
        color: #333 !important;
        width: 100% !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
      }
      
      /* Customer display styling */
      .modal-reviews-container .fera-customer-display {
        flex-direction: row !important;
        align-items: center !important;
        display: flex !important;
        width: 100% !important;
        margin-top: 10px !important;
        box-sizing: border-box !important;
      }
      
      .modal-reviews-container .fera-customer-display-avatar {
        margin-right: 10px !important;
        flex-shrink: 0 !important;
      }
      
      .modal-reviews-container .fera-customer-display-avatar img {
        width: 32px !important;
        height: 32px !important;
        border-radius: 50% !important;
      }
      
      .modal-reviews-container .fera-customer-display-name-text {
        font-size: 13px !important;
        color: #666 !important;
        flex: 1 !important;
        min-width: 0 !important;
      }
      
      /* Footer styling */
      .modal-reviews-container .fera-widget-footer {
        padding: 15px !important;
        text-align: center !important;
        margin: 0 !important;
        width: 100% !important;
      }
      
      .modal-reviews-container .fera-reviews-showMore-btn {
        width: 100% !important;
        max-width: 100% !important;
        padding: 12px !important;
        font-size: 14px !important;
        background: #f8f9fa !important;
        border: 1px solid #e5e7eb !important;
        border-radius: 6px !important;
        color: #333 !important;
        text-decoration: none !important;
        display: block !important;
        text-align: center !important;
        margin: 0 !important;
        box-sizing: border-box !important;
      }
      
      .modal-reviews-container .fera-reviews-showMore-btn:hover {
        background: #e9ecef !important;
        color: #333 !important;
      }
      
      /* Fix truncated text on mobile */
      .modal-reviews-container .fera-truncatedText--truncated {
        font-size: 14px !important;
        line-height: 1.4 !important;
        color: #333 !important;
        width: 100% !important;
        word-wrap: break-word !important;
      }
      
      .modal-reviews-container .fera-truncatedText-showMore {
        color: #007bff !important;
        text-decoration: underline !important;
        font-size: 13px !important;
      }
      
      /* Force mobile layout */
      .modal-reviews-container .fera-row {
        display: block !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      .modal-reviews-container .fera-col {
        width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
        display: block !important;
      }
      
      .modal-reviews-container .fera-customer-display-text {
        flex: 1 !important;
        min-width: 0 !important;
      }
      
      /* Additional mobile fixes */
      .modal-reviews-container * {
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
      
      .modal-reviews-container .fera-review-body p {
        margin: 0 0 10px 0 !important;
        word-wrap: break-word !important;
      }
      
      .modal-reviews-container .fera-review-body p:last-child {
        margin-bottom: 0 !important;
      }
      
      /* Hide unnecessary elements on mobile */
      .modal-reviews-container .fera-reviews-body-top {
        display: none !important;
      }
      
      .modal-reviews-container .fera-ratingSummary-toggle {
        display: none !important;
      }
      
      /* Show More text styling */
      .modal-reviews-container .fera-truncatedText-showMore {
        color: #007bff !important;
        text-decoration: underline !important;
        font-size: 13px !important;
        cursor: pointer !important;
        margin-left: 4px !important;
      }
      
      
      .modal-reviews-container .fera-truncatedText-showMore:hover {
        color: #0056b3 !important;
      }
      
      /* Show more reviews button styling */
      .modal-reviews-container .fera-reviews-showMore-btn {
        width: 100% !important;
        max-width: 100% !important;
        padding: 12px !important;
        font-size: 14px !important;
        background: #f8f9fa !important;
        border: 1px solid #e5e7eb !important;
        border-radius: 6px !important;
        color: #333 !important;
        text-decoration: none !important;
        display: block !important;
        text-align: center !important;
        margin: 0 !important;
        box-sizing: border-box !important;
        cursor: pointer !important;
        transition: background-color 0.2s ease !important;
      }
      
      .modal-reviews-container .fera-reviews-showMore-btn:hover {
        background: #e9ecef !important;
        color: #333 !important;
      }
      
      .modal-reviews-container .fera-reviews-showMore-btn:disabled {
        opacity: 0.6 !important;
        cursor: not-allowed !important;
      }
    }
    
    /* Desktop styling for Fera reviews in modal */
    @media (min-width: 769px) {
      .modal-reviews-container .fera-reviews-header {
        padding: 0 20px !important;
        margin-bottom: 20px !important;
      }
      
      /* Hide mobile-only review count on desktop too */
      .modal-reviews-container .fera-averageRating-count-str--min.fera-visible-xs {
        display: none !important;
      }
      
      /* Make rating and count display in one line on desktop - following product rating pattern */
      .modal-reviews-container .fera-averageRating {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        flex-wrap: nowrap !important;
        white-space: nowrap !important;
      }
      
      /* Order: Stars first, then rating number, then count - matching top widget */
      .modal-reviews-container .fera-averageRating-average-stars {
        order: 1 !important;
        flex-shrink: 0 !important;
      }

      .modal-reviews-container .fera-averageRating-average-number {
        order: 2 !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .modal-reviews-container .fera-averageRating-count {
        order: 3 !important;
        flex-shrink: 0 !important;
        padding-left: 8px !important;
        border-left: 1px solid #d1d5db !important;
      }
      
      /* Override Fera's grid system for rating on desktop */
      .modal-reviews-container .fera-reviews-header-summary-average-rating {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        flex-wrap: nowrap !important;
        white-space: nowrap !important;
      }
      
      .modal-reviews-container .fera-averageRating-average {
        display: flex !important;
        align-items: center !important;
        gap: 6px !important;
        flex-shrink: 0 !important;
      }
      
      /* Always show rating number, even on extra small screens */
      .modal-reviews-container .fera-averageRating-average-number.fera-hidden-xxs {
        display: inline !important;
      }
      
      .modal-reviews-container .fera-averageRating-count {
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
        flex-shrink: 0 !important;
      }
      
      /* Ensure stars don't wrap */
      .modal-reviews-container .fera-averageRating-average-stars {
        flex-shrink: 0 !important;
      }
      
      .modal-reviews-container .fera-reviews-body {
        padding: 0 20px !important;
      }
      
      .modal-reviews-container .fera-review {
        padding: 24px 0 !important;
        border-bottom: 1px solid #e5e7eb !important;
        margin-bottom: 0 !important;
      }
      
      .modal-reviews-container .fera-review:last-child {
        border-bottom: none !important;
      }
      
      .modal-reviews-container .fera-widget-footer {
        padding: 20px !important;
        text-align: center !important;
      }
      
      .modal-reviews-container .fera-reviews-showMore-btn {
        padding: 12px 24px !important;
        font-size: 14px !important;
        background: #f8f9fa !important;
        border: 1px solid #e5e7eb !important;
        border-radius: 6px !important;
        color: #333 !important;
        text-decoration: none !important;
        display: inline-block !important;
      }
      
      .modal-reviews-container .fera-reviews-showMore-btn:hover {
        background: #e9ecef !important;
      }
      
    }
    
  </style>
</div>`;
  
  // Prevent duplicate modals - remove any existing wrapper first
  const existingWrapper = document.querySelector(w.wrapper);
  if (existingWrapper) {
    existingWrapper.remove();
  }
  
  document.body.insertAdjacentHTML("beforeend", a);
  document.body.style.overflow = "hidden";
  document.documentElement.style.overflow = "hidden";
  
  // Add review section interactions after modal is created
  setTimeout(() => {
    const modal = document.getElementById('juo-box-product-details');
    if (modal) {
      
      // Handle clicks on Fera widget elements to scroll to reviews (only add once)
      if (!window.feraClickHandlerAdded) {
        document.addEventListener('click', function(e) {
          // Don't intercept "Show More" links for individual reviews or "Show more reviews" button
          if (e.target.matches('.fera-truncatedText-showMore') || 
              e.target.matches('.fera-reviews-showMore-btn') ||
              e.target.closest('.fera-truncatedText-showMore') ||
              e.target.closest('.fera-reviews-showMore-btn') ||
              e.target.textContent.includes('Show More') ||
              e.target.textContent.includes('Show more')) {
            return; // Let Fera handle these naturally
          }
          
          if (e.target.closest('.fera-averageRating, .fera-productDetailRating-widget, .fera-widget')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            // Remove any existing click handlers from Fera elements
            const feraElement = e.target.closest('.fera-averageRating, .fera-productDetailRating-widget, .fera-widget');
            if (feraElement) {
              feraElement.onclick = null;
              feraElement.style.pointerEvents = 'none';
              setTimeout(() => {
                feraElement.style.pointerEvents = 'auto';
              }, 100);
            }
            
            // Find the currently visible modal (not just the last created one)
            const activeModal = document.querySelector('#juo-box-product-details:not([style*="display: none"])');
            if (activeModal) {
              const reviewsSection = activeModal.querySelector('.modal-reviews-section');
              if (reviewsSection) {
                reviewsSection.scrollIntoView({ behavior: 'smooth' });
              }
            }
          }
        }, true); // Use capture phase to intercept before Fera's handlers
        window.feraClickHandlerAdded = true;
      }
      
      // Handle "Show Reply" button clicks
      modal.addEventListener('click', function(e) {
        if (e.target.matches('.modal-review-reply-action')) {
          e.preventDefault();
          const reply = e.target.closest('.modal-review-reply');
          const body = reply.querySelector('.modal-review-reply-body');
          const actions = reply.querySelector('.modal-review-reply-actions');
          
          if (body.style.display === 'none' || body.style.display === '') {
            body.style.display = 'block';
            actions.innerHTML = '<a href="#" class="modal-review-reply-action">Hide Reply</a>';
          } else {
            body.style.display = 'none';
            actions.innerHTML = '<a href="#" class="modal-review-reply-action">Show Reply (1)</a>';
          }
        }
      });
        
      // Fix "Show More Reviews" text to just "Show More" for individual reviews
      const fixShowMoreText = () => {
        const showMoreLinks = modal.querySelectorAll('.fera-truncatedText-showMore');
        showMoreLinks.forEach(link => {
          if (link.textContent.includes('Show More Reviews')) {
            link.textContent = 'Show More';
          }
        });
      };
      
      // Run immediately and then with MutationObserver
      fixShowMoreText();
      
      const observer = new MutationObserver(() => {
        fixShowMoreText();
      });
      
      observer.observe(modal, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      // Also run periodically to catch any missed changes
      setInterval(fixShowMoreText, 500);
    }
  }, 200);
  
  // Initialize Fera widgets for dynamic modal content
  setTimeout(() => {
    if (window.fera && typeof window.fera.refreshWidgets === 'function') {
      try {
        window.fera.refreshWidgets();
        
        // Hide reviews container if no reviews after widgets load
        setTimeout(() => {
          const reviewsContainer = document.querySelector('.modal-reviews-container');
          const reviewsWidget = reviewsContainer?.querySelector('[data-fera-widget="product_reviews"]');
          const reviewsBody = reviewsContainer?.querySelector('.fera-reviews-body-items');
          const reviewCount = reviewsContainer?.querySelector('[data-fera-rating-count]');
          
          // Check if there are no reviews
          if (reviewsContainer && reviewsWidget) {
            const hasNoReviews = !reviewsBody || reviewsBody.children.length === 0 || 
                                (reviewCount && (reviewCount.textContent === '0' || reviewCount.textContent === ''));
            
            if (hasNoReviews) {
              reviewsContainer.style.display = 'none';
            }
          }
          
        }, 500); // Give Fera time to load reviews
      } catch (e) {
        console.error('Fera refreshWidgets failed:', e);
      }
    } else if (window.Fera && typeof window.Fera.refreshWidgets === 'function') {
      try {
        window.Fera.refreshWidgets();
        
        // Hide reviews container if no reviews after widgets load
        setTimeout(() => {
          const reviewsContainer = document.querySelector('.modal-reviews-container');
          const reviewsWidget = reviewsContainer?.querySelector('[data-fera-widget="product_reviews"]');
          const reviewsBody = reviewsContainer?.querySelector('.fera-reviews-body-items');
          const reviewCount = reviewsContainer?.querySelector('[data-fera-rating-count]');
          
          // Check if there are no reviews
          if (reviewsContainer && reviewsWidget) {
            const hasNoReviews = !reviewsBody || reviewsBody.children.length === 0 || 
                                (reviewCount && (reviewCount.textContent === '0' || reviewCount.textContent === ''));
            
            if (hasNoReviews) {
              reviewsContainer.style.display = 'none';
            }
          }
          
        }, 500); // Give Fera time to load reviews
      } catch (e) {
        console.error('Fera refreshWidgets failed:', e);
      }
    }
    
    // Initialize Tolstoy widget for dynamic modal content
    if (window.tolstoyWidget && typeof window.tolstoyWidget.init === 'function') {
      try {
        window.tolstoyWidget.init();
      } catch (e) {
        console.error('Tolstoy widget init failed:', e);
      }
    }
  }, 100);
  
  
  
  // Fix mobile video poster issue
  const modalVideos = document.querySelectorAll('#juo-box-product-details video');
  modalVideos.forEach(video => {
    video.addEventListener('play', function() {
      this.removeAttribute('poster');
    });
    video.addEventListener('pause', function() {
      // Re-add poster when paused (optional)
      if (!this.hasAttribute('poster') && this.dataset.originalPoster) {
        this.setAttribute('poster', this.dataset.originalPoster);
      }
    });
    // Store original poster for restoration
    if (video.poster) {
      video.dataset.originalPoster = video.poster;
    }
  });
  
  return { wrapper: document.querySelector(w.wrapper) };
}

function q() {
  document.querySelector(w.wrapper) &&
    (document.body.style.removeProperty("overflow"),
    document.documentElement.style.removeProperty("overflow"),
    document.querySelector(w.wrapper).removeEventListener("click", this),
    document.querySelector(w.wrapper).remove());
}

function autoOpenModalFromHash() {
  // Extract hash and strip any UTM parameters (e.g., #14809221726578?utm_source=...)
  const hash = window.location.hash.slice(1).split('?')[0];
  if (!hash) return;
  
  // Find product element by ID
  const productElement = document.querySelector(`#product-${hash}`);
  if (!productElement) {
    // Product not found - ensure content is visible
    document.body?.classList.remove('modal-pending');
    document.getElementById('modal-pending-style')?.remove();
    return;
  }
  
  // If this is a hash-only product, show it and mark as revealed
  if (HASH_ONLY_PRODUCTS.includes(hash)) {
    productElement.style.display = 'block';
    REVEALED_PRODUCTS.add(hash);
    addApprovedHashProduct(hash); // Save to cookie for future visits
  }
  
  // Trigger the existing click handler for the product icon
  const iconElement = productElement.querySelector('.juo-box__product-icon');
  if (iconElement) {
    iconElement.click();
    
    // REORDER: Move hash product to top of grid
    const productContainer = document.querySelector('.juo-box__products');
    if (productContainer && productElement.parentNode === productContainer) {
      productContainer.insertBefore(productElement, productContainer.firstChild);
    }
    
    document.body?.classList.remove('modal-pending');
    document.getElementById('modal-pending-style')?.remove();
  }
}

// ============================================================================
// LOCKED PRODUCT - KLAVIYO INTEGRATION
// ============================================================================

// Helper: Detect mobile device
function isMobileDevice() {
  return window.innerWidth <= 768;
}

// Helper: Get appropriate Klaviyo form ID based on device
function getKlaviyoFormId(config) {
  if (!config) return null;
  
  const isMobile = isMobileDevice();
  
  // Use desktop form ID if available and on desktop
  if (!isMobile && config.klaviyoFormIdDesktop) {
    return config.klaviyoFormIdDesktop;
  }
  
  // Otherwise use mobile form ID (default)
  return config.klaviyoFormId;
}

// Handle lock button clicks
document.addEventListener('click', (e) => {
  const lockButton = e.target.closest('.hash-product-lock-button');
  if (!lockButton) return;
  
  const productId = lockButton.dataset.productId;
  const config = HASH_ONLY_CONFIG[productId];
  
  const formId = getKlaviyoFormId(config);
  if (!formId) return;
  
  // Store which product is being unlocked
  sessionStorage.setItem('ghf_unlocking_product', productId);
  
  // Open Klaviyo popup (device-specific)
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
});

// Listen for Klaviyo form submission
window.addEventListener('klaviyoForms', (event) => {
  if (event.detail?.type !== 'submit') return;
  
  const productId = sessionStorage.getItem('ghf_unlocking_product');
  if (!productId) return;
  
  // Unlock the product
  unlockProduct(productId);
  
  // Clean up
  sessionStorage.removeItem('ghf_unlocking_product');
});

(function () {
  function n() {
    let c = 0,
      i = null;

    // Initialize with member data by default (or if AB test active)
    const isEarlySaleTest = sessionStorage.getItem('early_sale_toggle_test') === 'treatment';
    let currentDataSource = isEarlySaleTest ? 'member' : 'member';
    let e = loadBoxData(currentDataSource);
    
    function loadBoxData(source) {
      // Check A/B test state for this function
      const testVariant = sessionStorage.getItem('juo_ab_test_variant');
      let dataId;
      if (testVariant === '2item') {
        dataId = source === 'member' ? 'juo-box-data-member-2item' : 'juo-box-data-2item';
      } else if (testVariant === '3item') {
        dataId = source === 'member' ? 'juo-box-data-member-3item' : 'juo-box-data-3item';
      } else {
        dataId = source === 'member' ? 'juo-box-data-member' : 'juo-box-data';
      }
      const dataElement = document.getElementById(dataId);
      
      if (!dataElement) {
        console.warn(`Data source ${dataId} not found, falling back to regular data`);
        const fallbackElement = document.getElementById('juo-box-data');
        if (!fallbackElement) return null;
        const t = JSON.parse(fallbackElement.innerText);
        const o = {};
        t.ids.map((p) => {
          const f = t.variants.find((x) => x.id == p);
          f != null && (o[p] = f.price);
        });
        return { prices: o, tiers: t.tiers, sellingPlans: t.sellingPlans, product: t.product, freeProduct: t.freeProduct, variants: t.variants, minItemsCount: t.minItemsCount, moneyFormat: t.moneyFormat };
      }
      
      const t = JSON.parse(dataElement.innerText),
        o = {};
      t.ids.map((p) => {
        const f = t.variants.find((x) => x.id == p);
        f != null && (o[p] = f.price);
      });
      
      
      return { prices: o, tiers: t.tiers, sellingPlans: t.sellingPlans, product: t.product, freeProduct: t.freeProduct, variants: t.variants, minItemsCount: t.minItemsCount, moneyFormat: t.moneyFormat };
    }
    
    // Add toggle event listener
    document.querySelectorAll('input[name="pricing-type"]').forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          currentDataSource = this.value;
          e = loadBoxData(currentDataSource);
          
          // Update all pricing based on toggle selection
          updateAllPricing(this.value);
          
          // Update message versions based on toggle
          const memberVersions = document.querySelectorAll('.member-version');
          const nonMemberVersions = document.querySelectorAll('.non-member-version');
          
          if (this.value === 'member') {
            memberVersions.forEach(el => el.style.display = 'inline');
            nonMemberVersions.forEach(el => el.style.display = 'none');
          } else {
            memberVersions.forEach(el => el.style.display = 'none');
            nonMemberVersions.forEach(el => el.style.display = 'inline');
          }
          
          // Show/hide member-only hash products based on toggle (including locked products)
          HASH_ONLY_PRODUCTS.forEach(productId => {
            const config = HASH_ONLY_CONFIG[productId];
            if (config?.memberOnly) {
              const productElement = document.querySelector(`#product-${productId}`);
              if (productElement) {
                // Check if product should show based on targeting rules
                const shouldShow = config?.locked ? 
                  shouldShowLockedProduct(productId, config) : 
                  (REVEALED_PRODUCTS.has(productId) || isProductApproved(productId));
                
                if (shouldShow) {
                  productElement.style.display = (this.value === 'member') ? 'block' : 'none';
                  
                  // If showing and locked, reapply lock overlay
                  if (this.value === 'member' && config?.locked && !isProductUnlocked(productId)) {
                    applyLockOverlay(productElement, productId, config);
                  }
                }
              }
            }
          });
          
          if (e) {
            // Clear current selections
            document.querySelectorAll('.juo-box__product-qty-input').forEach(input => {
              input.value = '0';
            });
            
            // Reset all Add to Box buttons
            document.querySelectorAll('.juo-box__add-to-box-btn').forEach(btn => {
              btn.style.display = 'block';
            });
            
            // Clear filters and presets
            const filterDropdown = document.querySelector('.juo-box__filter[data-filter="main"]');
            if (filterDropdown) filterDropdown.value = '';
            document.querySelectorAll('.juo-box__preset-btn').forEach(btn => btn.classList.remove('active'));
            document.querySelectorAll('.juo-box__product-qty').forEach(qty => {
              qty.style.display = 'none';
            });
            
            // Hide products that don't exist in current data source
            const availableVariantIds = new Set(e.variants.map(v => v.id.toString()));
            document.querySelectorAll('.juo-box__product').forEach(product => {
              const variantRow = product.querySelector('.juo-box__product-variant-row');
              const variantId = variantRow?.dataset.variant;
              
              if (variantId && !availableVariantIds.has(variantId)) {
                product.style.display = 'none';
              } else {
                product.style.display = '';
              }
            });
            
            // Update progress bar with new tiers
            document.dispatchEvent(new CustomEvent("juo-box:init-progress-bar", { detail: { tiers: e.tiers } }));
            
            // Get cart count even when builder is reset
            (async () => {
              let cartCount = 0;
              // PERFORMANCE FIX: Builder tracks its own state - no cart checking needed
              cartCount = 0; // Builder is reset, so cart count for this builder is 0
              
              document.dispatchEvent(new CustomEvent("juo-box:update-progress-bar", { detail: { totalQty: cartCount, tiers: e.tiers } }));
              document.dispatchEvent(new CustomEvent("juo-box:update-prices", { detail: { data: e, totalQty: cartCount, formValues: [], sellingPlanId: i } }));
            })();
            
            // Update form action if needed
            const form = document.getElementById('juo-box-form');
            if (form) {
              form.setAttribute('data-product-id', e.product.id);
            }
          }
        }
      });
    });

    // Initialize UI state to match loaded data
    function initializeUIState() {
      const memberRadio = document.querySelector('input[name="pricing-type"][value="member"]');
      if (memberRadio && memberRadio.checked) {
        // Trigger the change event to properly initialize member state
        memberRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Initialize UI state after a short delay to ensure DOM is ready
    setTimeout(initializeUIState, 100);

    if (!!!e.variants.length) return;

    document.dispatchEvent(new CustomEvent("juo-box:init-progress-bar", { detail: { tiers: e.tiers } }));
    
    // Initialize pricing on page load
    const initialToggle = document.querySelector('input[name="pricing-type"]:checked');
    if (initialToggle) {
      updateAllPricing(initialToggle.value);
    }

    const d = document.getElementById("juo-box-form");
    d.addEventListener("change", a);
    
    // Prevent duplicate click listeners
    if (!window.juoBoxClickListenerAdded) {
      document.addEventListener("click", s);
      window.juoBoxClickListenerAdded = true;
    }

    async function a() {
      v();
      await l();
      const totalQty = await b();
      
      // Get current toggle state and load correct data
      const currentToggle = document.querySelector('input[name="pricing-type"]:checked');
      const currentSource = currentToggle ? currentToggle.value : 'member';
      const currentData = loadBoxData(currentSource);
      
      document.dispatchEvent(new CustomEvent("juo-box:update-progress-bar", { detail: { totalQty: totalQty, tiers: currentData.tiers } }));
      document.dispatchEvent(new CustomEvent("juo-box:update-prices", { detail: { data: currentData, totalQty: totalQty, formValues: m(), sellingPlanId: i } }));
      
      // Update selected counter when quantities change
      if (typeof updateSelectedCount === 'function') {
        updateSelectedCount();
      }
    }

    function r(t) {
      return d.querySelector('input[name="' + t.getAttribute("data-qty-target") + '"]');
    }

    function s(t) {
      // Handle Add to Box button clicks
      if (t.target.matches(".juo-box__add-to-box-btn")) {
        const variantId = t.target.getAttribute("data-variant");
        const variantRow = t.target.closest('.juo-box__product-variant-row');
        const qtyContainer = variantRow.querySelector('.juo-box__product-qty');
        const qtyInput = variantRow.querySelector('.juo-box__product-qty-input');
        const productElement = t.target.closest('.juo-box__product');
        const productId = productElement?.id.replace('product-', '');
        const config = HASH_ONLY_CONFIG[productId];
        
        // Check if this is the gift product with dontCountTowardsMin
        if (config?.dontCountTowardsMin && config?.maxQuantity === 1) {
          // Check if already added (clicking to remove)
          if (t.target.classList.contains('gift-added')) {
            // Remove from box
            qtyInput.value = 0;
            t.target.textContent = 'Add to Box';
            t.target.classList.remove('gift-added');
            a();
          } else {
            // Add to box
            qtyInput.value = 1;
            t.target.textContent = 'Added';
            t.target.classList.add('gift-added');
            a();
          }
        } else {
          // Normal behavior: Hide Add to Box button, show quantity controls
          t.target.style.display = 'none';
          qtyContainer.style.display = 'flex';
          
          // Set quantity to 1
          qtyInput.value = 1;
          a();
        }
      }
      
      if (t.target.matches("button[data-qty-target]")) {
        const o = r(t.target);
        o.value == "" && (o.value = 0);
        
        // Check for max quantity limit
        const productContainer = t.target.closest('.juo-box__product');
        const productId = productContainer ? productContainer.id.replace('product-', '') : null;
        let maxQty = productId && HASH_ONLY_CONFIG[productId]?.maxQuantity;
        
        // If product is already in cart, set max to 0 (disable)
        if (productId && window.limitedProductInCart && window.limitedProductInCart[productId]) {
          maxQty = 0;
        }
        
        let newValue = Math.max(0, Number.parseInt(o.value ?? 0, 10) + Number.parseInt(t.target.getAttribute("data-qty-add"), 10));
        
        // Enforce max quantity if set
        if (maxQty !== undefined && newValue > maxQty) {
          newValue = maxQty;
        }
        
        o.value = newValue;
        
        // If quantity goes to 0, show Add to Box button again
        if (newValue === 0) {
          const variantRow = t.target.closest('.juo-box__product-variant-row');
          const addToBoxBtn = variantRow.querySelector('.juo-box__add-to-box-btn');
          const qtyContainer = variantRow.querySelector('.juo-box__product-qty');
          
          if (addToBoxBtn && qtyContainer) {
            addToBoxBtn.style.display = 'block';
            qtyContainer.style.display = 'none';
          }
        }
        
        a();
      }

      if (t.target.matches(".juo-box__product--enable-qty")) {
        t.preventDefault();
        document.querySelector('[data-variant="' + t.target.parentNode.querySelector("select").value + '"]').classList.add("visible");
        const o = document.querySelector('[data-variant="' + t.target.parentNode.querySelector("select").value + '"]').parentElement,
          p = o.querySelectorAll(".visible[data-variant]").length;
        o.querySelectorAll(".visible[data-variant]").forEach((f, x) => {
          f.classList.remove("last");
          x === p - 1 && f.classList.add("last");
        });
        document.querySelector('[data-variant="' + t.target.parentNode.querySelector("select").value + '"] [data-qty-add="1"]').click();
      }

 if (t.target.matches(".juo-box__product-icon") || t.target.closest('.product-image-wrapper')) {
  const o = t.target.matches(".juo-box__product-icon") ? 
    t.target.dataset.productId : 
    t.target.closest('.product-image-wrapper').dataset.productId;
  if (o == null) return;
  const p = document.querySelector(`#product-${o}`),
    f = p.querySelector(".juo-box__product-variant-row").dataset.variant;

        
        if (f == null) return;
        const x = e.variants.find((_) => _.id == f);
        j(x, p, e.moneyFormat);
        document.querySelector("#juo-box-product-details-wrapper").addEventListener("click", (_) => {
          _.target.matches("#juo-box-product-details-wrapper") && q();
        });
      }

      t.target.matches(".product-details-btn-close") && q();
      if (t.target.matches("[data-add-to-box]") || t.target.closest("[data-add-to-box]")) {
        const button = t.target.closest("[data-add-to-box]") || t.target;
        const variantId = button.dataset.variantId;
        const variantRow = document.querySelector('[data-variant="' + variantId + '"]');
        
        if (variantRow) {
          const addToBoxBtn = variantRow.closest('.juo-box__product-variant-row').querySelector('.juo-box__add-to-box-btn');
          const qtyContainer = variantRow.closest('.juo-box__product-variant-row').querySelector('.juo-box__product-qty');
          const qtyInput = variantRow.querySelector('input[type="number"]');
          
          // If "Add to Box" button is visible, click it first to switch to quantity selector
          if (addToBoxBtn && addToBoxBtn.style.display !== 'none') {
            addToBoxBtn.click();
          } else if (qtyContainer) {
            // Otherwise, increment the quantity
            const incrementBtn = variantRow.querySelector('[data-qty-add="1"]');
            if (incrementBtn) incrementBtn.click();
          }
        }
        
        q(); // Close modal
      }
    }

    function v() {
      d.querySelectorAll('button[data-qty-target][data-qty-add="-1"]').forEach(function (t) {
        const o = r(t);
        t.disabled = !(Number.parseInt(o.value, 10) > 0);
        t.disabled && t.parentNode.parentNode.classList.remove("visible");
      });
    }

    function m() {
      return Array.from(d.querySelectorAll(".juo-box__product-variant-row")).map(function (t) {
        const o = t.querySelector("input.variant-id").value,
          p = Number.parseInt(t.querySelector("input.juo-box__product-qty-input").value, 10);
        return { variantId: o, qty: p };
      });
    }

    async function b() {
      // Count builder items (excluding dontCountTowardsMin products)
      let builderCount = 0;
      d.querySelectorAll('input[name^="qty["]').forEach(function (o) {
        const qty = Number.parseInt(o.value, 10);
        if (qty > 0) {
          // Check if this product has dontCountTowardsMin flag
          const productElement = o.closest('.juo-box__product');
          const productId = productElement?.id.replace('product-', '');
          const config = HASH_ONLY_CONFIG[productId];
          
          // Skip counting if flagged as dontCountTowardsMin
          if (config?.dontCountTowardsMin) {
            return; // Don't count this product at all
          }
          
          builderCount += qty;
        }
      });
      
      // BULLETPROOF FIX: Always check cart when user changes builder (can't fail)
      let cartCount = 0;
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        const cartBoxItems = cart.items.filter(item => {
          return item.sku && item.sku.includes('-bab');
        });
        cartCount = cartBoxItems.reduce((sum, item) => sum + item.quantity, 0);
        
        // Check if limited products are in cart and disable/enable them in builder
        const productsInCart = checkMaxQuantityProductsInCart(cart.items);
        window.limitedProductInCart = productsInCart;
        
        // Get all max quantity products to enable/disable
        const maxQtyProducts = getMaxQuantityProducts();
        Object.keys(maxQtyProducts).forEach(productId => {
          const productElement = document.querySelector(`#product-${productId}`);
          if (productElement) {
            if (productsInCart[productId]) {
              // Disable product - it's in cart
              productElement.style.opacity = '0.5';
              productElement.style.pointerEvents = 'none';
            } else {
              // Enable product - it's NOT in cart
              productElement.style.opacity = '';
              productElement.style.pointerEvents = '';
            }
          }
        });
        
        // Update stored count
        window.buildABoxCartCount = cartCount;
      } catch (error) {
        console.log('Cart check failed, using stored:', error);
        cartCount = window.buildABoxCartCount || 0;
      }
      
      return builderCount + cartCount;
    }

    async function l() {
      const totalCount = await b();
      
      // Get builder count separately (excluding dontCountTowardsMin products)
      let builderCount = 0;
      d.querySelectorAll('input[name^="qty["]').forEach(function (o) {
        const qty = Number.parseInt(o.value, 10);
        if (qty > 0) {
          // Check if this product has dontCountTowardsMin flag
          const productElement = o.closest('.juo-box__product');
          const productId = productElement?.id.replace('product-', '');
          const config = HASH_ONLY_CONFIG[productId];
          
          // Skip counting if flagged as dontCountTowardsMin
          if (config?.dontCountTowardsMin) {
            return; // Don't count this product at all
          }
          
          builderCount += qty;
        }
      });
      
      const o = document.querySelector(".juo-box--add");
      // Check AB test variant
      const testVariant = sessionStorage.getItem('juo_ab_test_variant');
      const minItems = testVariant === '2item' ? 2 : (testVariant === '3item' ? 3 : (testVariant === '4item' ? 4 : 3));
      
      // Disable button if no builder items OR if total items < minimum
      const shouldEnable = builderCount > 0 && totalCount >= minItems;
      o != null && (shouldEnable ? (o.disabled = false, o.classList.remove("disabled")) : (o.disabled = true, o.classList.add("disabled")));
      
      // Add dynamic button text based on item count
      if (o != null) {
        if (totalCount >= minItems) {
          // If there are cart items, show "Add X Items To Box (Total)"
          if (totalCount > builderCount) {
            o.innerHTML = `Add ${builderCount} Item${builderCount === 1 ? '' : 's'} To Box (${totalCount})`;
          } else {
            // No cart items, use "Add Box To Cart"
            o.innerHTML = `Add Box To Cart (${totalCount})`;
          }
        } else {
          // Less than minimum total - dynamic logic
          const needed = minItems - totalCount;
          o.innerHTML = `Add ${needed} More Item${needed === 1 ? '' : 's'} (${totalCount}/${minItems})`;
        }
      }
      
      // Update pricing when item count changes (only for non-member)
      const currentToggle = document.querySelector('input[name="pricing-type"]:checked');
      if (currentToggle && currentToggle.value === 'regular') {
        updateAllPricing(currentToggle.value);
      }
    }

    function updateAllPricing(pricingType) {
      // Simple item count without depending on form variable
      let itemCount = 0;
      document.querySelectorAll('.juo-box__product-qty-input').forEach(input => {
        itemCount += parseInt(input.value || 0);
      });
      
      let discount;
      if (pricingType === 'member') {
        discount = 0.5; // Always 50% off for members
      } else {
        discount = itemCount >= 5 ? 0.5 : 0.65; // 50% off if 5+ items, otherwise 35% off
      }
      
      // Update grid pricing
      document.querySelectorAll('.juo-box__product').forEach(product => {
        const originalPrice = parseInt(product.dataset.price);
        const discountedPrice = Math.round((originalPrice / 100) * discount);
        
        const priceOriginal = product.querySelector('.price-original');
        const priceDiscounted = product.querySelector('.price-discounted');
        
        if (priceOriginal && priceDiscounted) {
          // Check for custom compareAtPrice override
          const productId = product.id.replace('product-', '');
          const customPrice = HASH_ONLY_CONFIG[productId]?.compareAtPrice;
          
          priceOriginal.textContent = '$' + (customPrice ? Math.round(customPrice / 100) : Math.round(originalPrice / 100));
          priceDiscounted.textContent = '$' + discountedPrice;
        }
      });
    }

    // Simple cart fetch function - only used when actually adding to cart
    async function y() {
      return (await fetch("/cart.js")).json();
    }

    async function h() {
      if (!d.reportValidity()) return;

      // Load membership product data
      let membershipProduct = null;
      const membershipDataElement = document.getElementById('membership-product-data');
      if (membershipDataElement) {
        try {
          membershipProduct = JSON.parse(membershipDataElement.textContent);
        } catch (e) {
          console.warn('Failed to parse membership product data:', e);
        }
      }

      const t = m();
      
      // Get current data source based on pricing toggle
      const currentToggle = document.querySelector('input[name="pricing-type"]:checked');
      const currentSource = currentToggle ? currentToggle.value : 'member';
      const currentData = loadBoxData(currentSource);
      const o = currentData.product;



      const p = await y();
      
      // Check if member pricing is selected
      const memberPricingSelected = document.querySelector('input[name="pricing-type"][value="member"]')?.checked;
      
      // Prepare cart items
      let cartItems = t
        .filter(({ qty: f }) => f > 0)
        .map(({ variantId: f, qty: x }) => ({
          id: parseInt(f, 10),
          quantity: x,
          properties: { _box: `box-${o.id}`, _parent_product_handle: `${o.handle}`, _parent_product_id: `${o.id}` },
          ...(i ? { selling_plan: parseInt(i, 10) } : {}),
        }));

      // Add free product if applicable
      if (o.freeId.length > 0 && (p.items.length === 0 || !p.items.find((f) => f.variant_id && f.variant_id == o.freeId))) {
        cartItems.push({
          id: parseInt(o.freeId, 10),
          quantity: 1,
          properties: { _box: `box-${o.id}`, _parent_product_handle: `${o.handle}` }
        });
      }

      // Add membership product if member pricing is selected
      if (memberPricingSelected && membershipProduct) {
        // Check if user is already a logged in member (has any of these tags)
        const isActiveSubscriber = window.customer && window.customer.tags && 
          (window.customer.tags.includes('active_subscriber') ||
           window.customer.tags.includes('Priority_Pass') ||
           window.customer.tags.includes('new_member'));
        
        // Check if AB test is active (treat like members - no membership product)
        const isEarlySaleTest = sessionStorage.getItem('early_sale_toggle_test') === 'treatment';
        
        // Check if membership product is already in cart
        const membershipInCart = window.isMembershipInCart(p.items);
        
        // Only add membership if user is not already a member AND not in AB test AND membership is not in cart
        if (!isActiveSubscriber && !isEarlySaleTest && !membershipInCart) {
          cartItems.push({
            id: parseInt(membershipProduct.variantId, 10),
            quantity: 1,
            selling_plan: parseInt(membershipProduct.sellingPlanId, 10),
            properties: { 
              _membership: 'true',
              _box: `box-${o.id}`,
              _parent_product_handle: `${o.handle}`,
              _membership_title: 'Membership'
            }
          });
        }
      }
      
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { 
            [`_box-${o.id}-savings`]: c,
            ...(memberPricingSelected ? { '_membership_selected': 'true' } : {})
          },
          items: cartItems.reverse(),
        }),
      });

      // MINIMAL CART INTEGRATION - START
      // Update cart count and open cart drawer after successful build-a-box submission
      try {
        // Fetch updated cart to get new count
        const updatedCart = await fetch('/cart.js').then(r => r.json());
        
        // Update cart count in header
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count-bubble span, button[aria-label*="Cart"] span');
        cartCountElements.forEach(el => {
          if (el.textContent.match(/\d+/)) {
            el.textContent = updatedCart.item_count;
          }
        });
        
        // Update cart button text
        const cartButton = document.querySelector('button[aria-label*="Cart"]');
        if (cartButton) {
          cartButton.setAttribute('aria-label', `Cart ${updatedCart.item_count} items`);
        }
        
        // Open cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('active');
          
          // CRITICAL FIX: Remove is-empty class when build-a-box items are added
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
        }
        
        // Also remove is-empty from cart-drawer-items
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems && cartDrawerItems.classList.contains('is-empty')) {
          cartDrawerItems.classList.remove('is-empty');
        }
      } catch (error) {
        console.error('Error updating cart display:', error);
      }
      // MINIMAL CART INTEGRATION - END

      document.dispatchEvent(new CustomEvent("cart:build"));
      document.dispatchEvent(new CustomEvent("cartUpdated", { detail: { message: "Cart was updated" } }));
      
      // Clear builder after successful cart add
      document.querySelectorAll('.juo-box__product').forEach(product => {
        const input = product.querySelector('.juo-box__product-qty-input');
        const addBtn = product.querySelector('.juo-box__add-to-box-btn');
        const qtyContainer = product.querySelector('.juo-box__product-qty');
        
        // Reset quantity to 0
        if (input && input.value !== '0') {
          input.value = '0';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        // Hide quantity controls and show Add to Box button
        if (qtyContainer) {
          qtyContainer.style.display = 'none';
        }
        if (addBtn) {
          addBtn.style.display = '';
        }
      });
      
      // Clear filters and presets
      const filterDropdown = document.querySelector('.juo-box__filter[data-filter="main"]');
      if (filterDropdown) filterDropdown.value = '';
      document.querySelectorAll('.juo-box__preset-btn').forEach(btn => btn.classList.remove('active'));
      
      // Directly trigger membership widget check instead of event cascade
      setTimeout(() => {
        if (typeof window.checkForMembershipAndHideWidget === 'function') {
          window.checkForMembershipAndHideWidget();
        }
      }, 500);
      // Let gift modal system handle cart opening
      // document.querySelector('.drawer').classList.add('active');
      // document.querySelector('.drawer').classList.remove('is-empty');
      // if (document.querySelector('.drawer__inner-empty')) document.querySelector('.drawer__inner-empty').style.display = 'none';

    }

    const g = document.querySelector(".juo-box--add");
    
    // Prevent duplicate event listeners
    if (g != null && !g.hasAttribute('data-listener-attached')) {
      g.setAttribute('data-listener-attached', 'true');
      g.addEventListener("click", async (t) => {
        t.preventDefault();
        await h();
      });
    }
    
    a();
    
    // Only attach these once
    if (!window.juoBoxEventsAttached) {
      window.juoBoxEventsAttached = true;
      document.addEventListener("juo-box:selected-selling-plan", (t) => {
        i = t.detail.sellingPlanId;
        a();
      });
      document.addEventListener("juo-box:savings-calculated", (t) => {
        c = t.detail.savings;
      });
      window.addEventListener("load", l);
    }
      
      // Auto-open modal from URL hash - execute ASAP without delays
      if (window.location.hash) {
        // Try to open immediately if products are ready
        autoOpenModalFromHash();
        // Fallback: also try when DOM is fully ready (but no artificial delay)
        if (document.readyState === "complete") {
          autoOpenModalFromHash();
        } else {
          document.addEventListener("DOMContentLoaded", autoOpenModalFromHash);
        }
        
        // REMOVED: 500ms delay backup - sorting logic now handles this
      }
      
      // Listen for hash changes after initial load
      window.addEventListener("hashchange", autoOpenModalFromHash);
  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", n) : n();
})();

// Define global preset button functionality
window.initGlobalPresetButtons = function() {
    const presetButtons = document.querySelectorAll('.juo-box__preset-btn');
    if (!presetButtons.length) return;
    
    presetButtons.forEach(button => {
        // Remove any existing listeners
        button.removeEventListener('click', button._presetHandler);
        
        // Create new handler
        button._presetHandler = function() {
            console.log('Preset button clicked:', this.dataset.preset);
            const preset = this.dataset.preset;
            
            // Remove active state from all buttons
            presetButtons.forEach(btn => btn.classList.remove('active'));
            
            // Add active state to clicked button
            this.classList.add('active');
            
            // Reset all items - set quantities to 0
            document.querySelectorAll('.juo-box__product').forEach(product => {
                const input = product.querySelector('.juo-box__product-qty-input');
                const addBtn = product.querySelector('.juo-box__add-to-box-btn');
                const qtyContainer = product.querySelector('.juo-box__product-qty');
                
                // Reset quantity to 0
                if (input && input.value !== '0') {
                    input.value = '0';
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
                
                // Hide quantity selector, show "Add to Box" button
                if (qtyContainer) {
                    qtyContainer.style.display = 'none';
                }
                if (addBtn) {
                    addBtn.style.display = '';
                }
            });
            
            // Set filter based on preset selection
            let filterValue = '';
            switch(preset) {
                case 'bestseller':
                    filterValue = 'filter_popular';
                    break;
                case 'specialty':
                    filterValue = 'filter_specialty';
                    break;
                case 'exotic':
                    filterValue = 'filter_exotic';
                    break;
            }
            
            if (filterValue) {
                // Clear all checkboxes first
                const checkboxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]');
                checkboxes.forEach(cb => cb.checked = false);
                
                // Check the matching checkbox
                const targetCheckbox = document.querySelector(`.juo-box__filter-checkbox input[value="${filterValue}"]`);
                if (targetCheckbox) {
                    targetCheckbox.checked = true;
                }
                
                // Update filters
                if (window.activeFilters) {
                    window.activeFilters.main = [filterValue];
                    window.activeFilters.selected = false;
                }
                
                // Reset Selected button
                const selectedButton = document.querySelector('[data-filter-type="selected"]');
                if (selectedButton) {
                    selectedButton.classList.remove('active');
                    selectedButton.innerHTML = 'Selected <span class="juo-box__selected-count">0</span>';
                }
                
                // Update UI
                if (window.updateFilterCount) window.updateFilterCount();
                if (window.filterProducts) window.filterProducts();
                
                // Wait for filter, then add items (2/3/4 based on variant)
                setTimeout(() => {
                    const testVariant = sessionStorage.getItem('juo_ab_test_variant');
                    const itemCount = testVariant === '2item' ? 2 : (testVariant === '3item' ? 3 : 4);
                    // FIX: Filter out hash/pinned products before selecting preset items
                    const visibleProducts = Array.from(document.querySelectorAll('.juo-box__product'))
                        .filter(p => {
                            if (p.style.display === 'none') return false;
                            const productId = p.id.replace('product-', '');
                            return !HASH_ONLY_PRODUCTS.includes(productId);
                        });
                    const itemsToAdd = visibleProducts.slice(0, itemCount);
                    
                    // Set all values first without triggering events
                    itemsToAdd.forEach(product => {
                        const addBtn = product.querySelector('.juo-box__add-to-box-btn');
                        const qtyContainer = product.querySelector('.juo-box__product-qty');
                        const input = product.querySelector('.juo-box__product-qty-input');
                        
                        if (qtyContainer) qtyContainer.style.display = 'flex';
                        if (addBtn) addBtn.style.display = 'none';
                        if (input) {
                            input.value = '1';
                        }
                    });
                    
                    // Show the summary wrapper (floating ATC section)
                    const summaryWrapper = document.querySelector('.juo-box__summary-wrapper');
                    if (summaryWrapper) {
                        summaryWrapper.classList.add('show');
                    }
                    
                    // Trigger single change event on the form to update everything at once
                    const form = document.getElementById('juo-box-form');
                    if (form) {
                        form.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    
                    // Force update counters after all changes
                    setTimeout(() => {
                        if (window.updateSelectedCount) window.updateSelectedCount();
                    }, 50);
                }, 100);
            }
        };
        
        // Attach new handler
        button.addEventListener('click', button._presetHandler);
    });
};

// Auto-initialize preset buttons when DOM is ready
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", window.initGlobalPresetButtons);
} else {
    window.initGlobalPresetButtons();
}

// Define updateSelectedCount globally at the top level
window.updateSelectedCount = function() {
    let totalQuantity = 0;
    
    // Count total quantities (not unique products)
    document.querySelectorAll('.juo-box__product').forEach(product => {
        const qtyInput = product.querySelector('.juo-box__product-qty-input');
        if (qtyInput) {
            const qty = parseInt(qtyInput.value) || 0;
            totalQuantity += qty;
        }
    });
    
    const selectedCountElement = document.querySelector('.juo-box__selected-count');
    const selectedButton = document.querySelector('[data-filter-type="selected"]');
    
    if (selectedCountElement) {
        selectedCountElement.textContent = totalQuantity;
        selectedCountElement.style.display = 'inline';
    }
    
    // Toggle black styling based on item count
    if (selectedButton) {
        if (totalQuantity > 0) {
            selectedButton.classList.add('has-items');
        } else {
            selectedButton.classList.remove('has-items');
        }
    }
    
    return totalQuantity;
};

(function() {
function initFilters() {
    const filters = document.querySelectorAll('.juo-box__filter');
    const products = document.querySelectorAll('.juo-box__product');
    const noResults = document.querySelector('.juo-box__no-results');
    const summaryWrapper = document.querySelector('.juo-box__summary-wrapper');
    
    // New filter panel elements
    const filterButtons = document.querySelectorAll('.juo-box__filter-btn');
    const filterPanel = document.querySelector('.juo-box__filter-panel');
    const filterPanelClose = document.querySelector('.juo-box__filter-panel-close');
    const filterPanelBackdrop = document.querySelector('.juo-box__filter-panel-backdrop');
    const filterSections = document.querySelectorAll('.juo-box__filter-section');
    
    let activeFilters = {
      main: [],
      search: '',
      selected: false
    };
    
    // Make activeFilters globally accessible for preset buttons
    window.activeFilters = activeFilters;

    // Initialize new filter panel functionality
    initFilterPanel();

    function initFilterPanel() {
        // Filter button click handlers
        filterButtons.forEach(button => {
            button.addEventListener('click', function() {
                const filterType = this.getAttribute('data-filter-type');
                openFilterPanel(filterType);
            });
        });

        // Close panel handlers
        if (filterPanelClose) {
            filterPanelClose.addEventListener('click', closeFilterPanel);
        }
        
        if (filterPanelBackdrop) {
            filterPanelBackdrop.addEventListener('click', closeFilterPanel);
        }

        // Escape key to close panel
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && filterPanel && filterPanel.style.display !== 'none') {
                closeFilterPanel();
            }
        });

        // Checkbox change handlers
        const filterCheckboxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]');
        filterCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                updateFilterCount();
                updateApplyButtonState();
            });
        });

        // Apply button handler
        const applyButton = document.querySelector('.juo-box__filter-apply');
        if (applyButton) {
            applyButton.addEventListener('click', applyFilters);
        }

        // Clear all button handler
        const clearButton = document.querySelector('.juo-box__filter-clear');
        if (clearButton) {
            clearButton.addEventListener('click', clearAllFilters);
        }

        // Selected count updates are now handled by existing quantity change system

        // Initial selected count update
        window.updateSelectedCount();

        // Show all items button handler (in selected section)
        const showAllButton = document.querySelector('.juo-box__filter-show-all');
        if (showAllButton) {
            showAllButton.addEventListener('click', function() {
                activeFilters.selected = false;
                activeFilters.main = [];
                const selectedButton = document.querySelector('[data-filter-type="selected"]');
                if (selectedButton) {
                    selectedButton.classList.remove('active');
                    const currentCount = window.updateSelectedCount();
                    selectedButton.innerHTML = 'Selected <span class="juo-box__selected-count">' + currentCount + '</span>';
                }
                filterProducts();
                updateFilterCount();
                window.updateSelectedCount();
                closeFilterPanel();
            });
        }
    }

    function openFilterPanel(filterType) {
        // Handle selected filter - toggle active state, NO PANEL
        if (filterType === 'selected') {
            const selectedButton = document.querySelector('[data-filter-type="selected"]');
            
            // Check if there are any selected items (count > 0)
            // BUT allow clicking if we're currently showing selected items (button shows "All Fruit")
            const currentCount = window.updateSelectedCount();
            const buttonText = selectedButton.textContent || selectedButton.innerText;
            const isShowingAllFruit = buttonText.includes('All Fruit');
            
            // FIX: If showing "All Fruit" text, always allow toggle back
            // If count is 0 and showing "Selected", don't allow entering Selected view (nothing to show)
            if (currentCount === 0 && !isShowingAllFruit && !activeFilters.selected) {
                // Do nothing if no items selected AND we're not in "All Fruit" mode
                return;
            }
            
            // Toggle selected filter state
            activeFilters.selected = !activeFilters.selected;
            
            if (activeFilters.selected) {
                // Clear other filters when showing selected
                activeFilters.main = [];
                selectedButton.classList.add('active');
                
                // Clear category filter checkboxes
                const checkboxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]');
                checkboxes.forEach(cb => cb.checked = false);
                updateFilterCount();
                
                // Change button text to "All Fruit" (keep white styling, no active class)
                selectedButton.classList.remove('active');
                selectedButton.innerHTML = 'All Fruit <span class="juo-box__selected-count">' + currentCount + '</span>';
            } else {
                selectedButton.classList.remove('active');
                
                // Change button text back to "Selected"
                selectedButton.innerHTML = 'Selected <span class="juo-box__selected-count">' + currentCount + '</span>';
            }
            
            filterProducts();
            window.updateSelectedCount();
            
            // Exit early - no panel for selected
            return;
        }
        
        // Clear selected filter when using other filters
        activeFilters.selected = false;
        const selectedButton = document.querySelector('[data-filter-type="selected"]');
        if (selectedButton) {
            selectedButton.classList.remove('active');
            const currentCount = window.updateSelectedCount();
            selectedButton.innerHTML = 'Selected <span class="juo-box__selected-count">' + currentCount + '</span>';
        }
        
        // Continue with panel opening for other filter types
        if (!filterPanel) return;
        
        // Show the panel
        filterPanel.style.display = 'block';
        
        // Add show class for animation after a brief delay
        setTimeout(() => {
            filterPanel.classList.add('show');
        }, 10);
        
        // Hide all sections first
        filterSections.forEach(section => {
            section.style.display = 'none';
        });
        
        // Show the correct section
        const targetSection = document.querySelector(`[data-section="${filterType}"]`);
        if (targetSection) {
            targetSection.style.display = 'block';
        }
        
        // Update button active states
        filterButtons.forEach(btn => btn.classList.remove('active'));
        const activeButton = document.querySelector(`[data-filter-type="${filterType}"]`);
        if (activeButton) {
            activeButton.classList.add('active');
        }
        
        // Update panel title based on filter type
        const panelTitle = document.querySelector('.juo-box__filter-panel-title');
        if (panelTitle) {
            switch(filterType) {
                case 'categories':
                    panelTitle.textContent = 'Filters';
                    break;
                case 'search':
                    panelTitle.textContent = 'Search Products';
                    break;
            }
        }
        
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
    }

    function closeFilterPanel() {
        if (!filterPanel) return;
        
        // Remove show class for animation
        filterPanel.classList.remove('show');
        
        // Hide panel after animation completes
        setTimeout(() => {
            filterPanel.style.display = 'none';
        }, 300);
        
        // Remove active states from buttons
        filterButtons.forEach(btn => btn.classList.remove('active'));
        
        // Restore body scroll
        document.body.style.overflow = '';
    }

    function updateFilterCount() {
        const checkedBoxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]:checked');
        const filterCount = document.querySelector('.juo-box__filter-count');
        
        if (filterCount) {
            if (checkedBoxes.length > 0) {
                filterCount.textContent = checkedBoxes.length;
                filterCount.style.display = 'inline';
            } else {
                filterCount.style.display = 'none';
            }
        }
    }
    
    // Make functions globally accessible for preset buttons
    window.updateFilterCount = updateFilterCount;
    window.filterProducts = filterProducts;

    function updateApplyButtonState() {
        const checkedBoxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]:checked');
        const applyButton = document.querySelector('.juo-box__filter-apply');
        
        if (applyButton) {
            // Always keep the Apply button active/clickable
            applyButton.classList.add('active');
        }
    }


    function applyFilters() {
        // Get all checked filter values
        const checkedBoxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]:checked');
        activeFilters.main = Array.from(checkedBoxes).map(cb => cb.value);
        
        // Clear selected filter when applying category filters
        activeFilters.selected = false;
        const selectedButton = document.querySelector('[data-filter-type="selected"]');
        if (selectedButton) {
            selectedButton.classList.remove('active');
            const currentCount = window.updateSelectedCount();
            selectedButton.innerHTML = 'Selected <span class="juo-box__selected-count">' + currentCount + '</span>';
        }
        
        // Remove active state from all preset buttons
        const presetButtons = document.querySelectorAll('.juo-box__preset-btn');
        presetButtons.forEach(btn => btn.classList.remove('active'));
        
        // Apply the filters
        filterProducts();
        
        // Update filter count on button
        updateFilterCount();
        updateApplyButtonState();
        
        // Close the panel
        closeFilterPanel();
        
        // Show summary if filters are applied
        if (activeFilters.main.length > 0 && summaryWrapper) {
            summaryWrapper.classList.add('show');
            hasInteracted = true;
        }
    }

    function clearAllFilters() {
        // Uncheck all checkboxes
        const checkboxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]');
        checkboxes.forEach(cb => cb.checked = false);
        
        // Clear active filters
        activeFilters.main = [];
        activeFilters.selected = false;
        
        // Remove active states from all buttons
        const selectedButton = document.querySelector('[data-filter-type="selected"]');
        if (selectedButton) {
            selectedButton.classList.remove('active');
            const currentCount = window.updateSelectedCount();
            selectedButton.innerHTML = 'Selected <span class="juo-box__selected-count">' + currentCount + '</span>';
        }
        
        // Remove active state from all preset buttons
        const presetButtons = document.querySelectorAll('.juo-box__preset-btn');
        presetButtons.forEach(btn => btn.classList.remove('active'));
        
        // Apply filters (show all)
        filterProducts();
        
        // Update count display
        updateFilterCount();
        updateApplyButtonState();
        window.updateSelectedCount();
        
        // Close panel
        closeFilterPanel();
    }

    // Handle scroll
let hasInteracted = false;

// Show on 50% scroll or when items are added
window.addEventListener('scroll', () => {
    if (!hasInteracted) {
        const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        if (scrollPercent > 50) {
            summaryWrapper.classList.add('show');
            hasInteracted = true;
        }
    }
});

// Show on filter change
filters.forEach(filter => {
    filter.addEventListener('change', () => {
        summaryWrapper.classList.add('show');
        hasInteracted = true;
    });
});

// Show when user adds item (quantity buttons)
document.querySelectorAll('.juo-box__product-qty-btn').forEach(button => {
    button.addEventListener('click', () => {
        summaryWrapper.classList.add('show');
        hasInteracted = true;
    });
});

// Show when user clicks "Add to Box" button
document.querySelectorAll('.juo-box__add-to-box-btn').forEach(button => {
    button.addEventListener('click', () => {
        summaryWrapper.classList.add('show');
        hasInteracted = true;
    });
});

// Show when user clicks "Add" button
document.querySelectorAll('.juo-box__product--enable-qty').forEach(button => {
    button.addEventListener('click', () => {
        summaryWrapper.classList.add('show');
        hasInteracted = true;
    });
});

function handleScroll() {
    const checkoutWrapper = document.querySelector('.juo-box__checkout-wrapper');
    const scrollPosition = window.scrollY;
    const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
    
    // Show checkout when user scrolls 20% of the page
    const filters = window.activeFilters || { main: [], selected: false };
    const hasActiveFilters = filters.main.length > 0 || filters.selected;
    if (scrollPosition > (pageHeight * 0.2) || hasActiveFilters) {
        checkoutWrapper.classList.add('show');
    } else {
        checkoutWrapper.classList.remove('show');
    }
}

    // Initialize the scroll handler
    window.addEventListener('scroll', handleScroll);

    // Also show summary when filter changes
    const filterElement = document.querySelector('.juo-box__filter');
    if (filterElement) {
        filterElement.addEventListener('change', function() {
            document.querySelector('.juo-box__summary-wrapper').classList.add('show');
        });
    }

    // Initial check in case page is already scrolled
    handleScroll();
    
    // Preset buttons now handled by global system
    
    function initPresetButtons() {
        const presetButtons = document.querySelectorAll('.juo-box__preset-btn');
        if (!presetButtons.length) return;
        
        presetButtons.forEach(button => {
            button.addEventListener('click', function() {
                const preset = this.dataset.preset;
                
                // Remove active state from all buttons
                presetButtons.forEach(btn => btn.classList.remove('active'));
                
                // Add active state to clicked button
                this.classList.add('active');
                
                // Reset all items - set quantities to 0 and hide quantity selectors
                document.querySelectorAll('.juo-box__product').forEach(product => {
                    const input = product.querySelector('.juo-box__product-qty-input');
                    const addBtn = product.querySelector('.juo-box__add-to-box-btn');
                    const qtyContainer = product.querySelector('.juo-box__product-qty');
                    
                    // Reset quantity to 0
                    if (input && input.value !== '0') {
                        input.value = '0';
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    
                    // Hide quantity selector, show "Add to Box" button
                    if (qtyContainer) {
                        qtyContainer.style.display = 'none';
                    }
                    if (addBtn) {
                        addBtn.style.display = '';
                    }
                });
                
                // Set filter based on preset selection
                let filterValue = '';
                
                switch(preset) {
                    case 'bestseller':
                        filterValue = 'filter_popular';
                        break;
                    case 'specialty':
                        filterValue = 'filter_specialty';
                        break;
                    case 'exotic':
                        filterValue = 'filter_exotic';
                        break;
                }
                
                // Update new checkbox system and apply filter
                if (filterValue) {
                    // Clear all checkboxes first
                    const checkboxes = document.querySelectorAll('.juo-box__filter-checkbox input[type="checkbox"]');
                    checkboxes.forEach(cb => cb.checked = false);
                    
                    // Check the matching checkbox
                    const targetCheckbox = document.querySelector(`.juo-box__filter-checkbox input[value="${filterValue}"]`);
                    if (targetCheckbox) {
                        targetCheckbox.checked = true;
                    }
                    
                    // Update filters and apply
                    window.activeFilters.main = [filterValue];
                    window.activeFilters.selected = false;
                    
                    // Reset Selected button text if needed
                    const selectedButton = document.querySelector('[data-filter-type="selected"]');
                    if (selectedButton) {
                        selectedButton.classList.remove('active');
                        const currentCount = window.updateSelectedCount();
                        selectedButton.innerHTML = 'Selected <span class="juo-box__selected-count">' + currentCount + '</span>';
                    }
                    
                    // Update filter count badge to show 1 filter applied
                    window.updateFilterCount();
                    if (typeof updateApplyButtonState === 'function') {
                        updateApplyButtonState();
                    }
                    
                    // Apply the filter immediately
                    window.filterProducts();
                    
                    // Show summary since we're applying filters
                    const summaryWrapper = document.querySelector('.juo-box__summary-wrapper');
                    if (summaryWrapper) {
                        summaryWrapper.classList.add('show');
                    }
                }
                
                // Wait for filter to be applied, then select top items (2/3/4 based on variant)
                setTimeout(() => {
                    const testVariant = sessionStorage.getItem('juo_ab_test_variant');
                    const itemCount = testVariant === '2item' ? 2 : (testVariant === '3item' ? 3 : 4);
                    // Get the visible, sorted products after filter is applied
                    const visibleProducts = Array.from(document.querySelectorAll('.juo-box__product')).filter(p => p.style.display !== 'none');
                    const itemsToAdd = visibleProducts.slice(0, itemCount);
                    
                    // Add the selected items
                    itemsToAdd.forEach(product => {
                        if (product) {
                            const addBtn = product.querySelector('.juo-box__add-to-box-btn');
                            const qtyContainer = product.querySelector('.juo-box__product-qty');
                            const input = product.querySelector('.juo-box__product-qty-input');
                            
                            // Show quantity selector and hide add button
                            if (qtyContainer) {
                                qtyContainer.style.display = 'flex';
                            }
                            if (addBtn) {
                                addBtn.style.display = 'none';
                            }
                            
                            // Set quantity to 1
                            if (input) {
                                input.value = '1';
                                input.dispatchEvent(new Event('change', { bubbles: true }));
                                
                                // Update minus button state
                                const minusBtn = product.querySelector('[data-qty-add="-1"]');
                                if (minusBtn) {
                                    minusBtn.disabled = false;
                                }
                            }
                        }
                    });
                    
                    // Show summary if not already visible
                    if (summaryWrapper && !summaryWrapper.classList.contains('show')) {
                        summaryWrapper.classList.add('show');
                        hasInteracted = true;
                    }
                    
                    // Scroll to products section
                    const productsSection = document.querySelector('.juo-box__products');
                    if (productsSection) {
                        const yOffset = -100;
                        const y = productsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({top: y, behavior: 'smooth'});
                    }
                }, 100); // Small delay to ensure filter is applied
            });
        });
        
        // Remove active state when user manually changes quantities
        document.querySelectorAll('.juo-box__product-qty-btn, .juo-box__add-to-box-btn').forEach(btn => {
            btn.addEventListener('click', function() {
                presetButtons.forEach(btn => btn.classList.remove('active'));
            });
        });
    }

    // Rest of your existing code continues below...

    
function filterProducts(isInitialLoad = false) {
  // Use global activeFilters if local one not available
  const filters = window.activeFilters || activeFilters;
  let visibleProducts = 0;
  const productList = document.querySelector('.juo-box__products');
  let productArray = Array.from(products);
  
  // Scroll to products section with offset (skip on initial load)
  if (!isInitialLoad) {
    const yOffset = -100; // Adjust this value to fine-tune the scroll position
    const element = document.querySelector('.juo-box__products');
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
  }
  
  productArray.forEach(product => {
    let shouldShow = true;
    
    // Multi-filter logic - if no filters selected, show all
    if (filters.main && filters.main.length > 0) {
      shouldShow = false; // Start with false, any match will set to true
      
      // Check each selected filter (OR logic within filters)
      for (const filterValue of filters.main) {
        let matchesThisFilter = false;
        
        switch(filterValue) {
  case 'filter_popular':
    const tagsPopular = product.dataset.tags ? product.dataset.tags.split(',').map(t => t.trim()) : [];
            matchesThisFilter = tagsPopular.includes('filter_popular');
    break;
  case 'new_fruit':
    const tagsNew = product.dataset.tags ? product.dataset.tags.split(',').map(t => t.trim()) : [];
            matchesThisFilter = tagsNew.includes('new_fruit');
    break;
  case 'filter_variety':
    const tagsVariety = product.dataset.tags ? product.dataset.tags.split(',').map(t => t.trim()) : [];
            matchesThisFilter = tagsVariety.includes('filter_variety');
    break;
  case 'filter_specialty':
    const tagsSpecialty = product.dataset.tags ? product.dataset.tags.split(',').map(t => t.trim()) : [];
            matchesThisFilter = tagsSpecialty.includes('filter_specialty');
    break;
  case 'filter_exotic':
    const tagsExotic = product.dataset.tags ? product.dataset.tags.split(',').map(t => t.trim()) : [];
            matchesThisFilter = tagsExotic.includes('filter_exotic');
    break;
  case 'var_winter':
    const tagsWinter = product.dataset.tags ? product.dataset.tags.split(',').map(t => t.trim()) : [];
            matchesThisFilter = tagsWinter.includes('var_winter');
    break;
  case 'filter_pantry':
    const tagsPantry = product.dataset.tags ? product.dataset.tags.split(',').map(t => t.trim()) : [];
            matchesThisFilter = tagsPantry.includes('filter_pantry');
    break;
  case '🍏 Crispy':
    const productTextureCrispy = product.dataset.textureClean || product.dataset.texture;
            matchesThisFilter = productTextureCrispy && (
      productTextureCrispy === '🍏 Crispy' ||
      productTextureCrispy.toLowerCase().includes('crispy')
    );
    break;
  case '🍭 Sweet':
    const productFlavourSweet = product.dataset.flavourClean || product.dataset.flavour;
            matchesThisFilter = productFlavourSweet && (
      productFlavourSweet === '🍭 Sweet' || 
      productFlavourSweet.toLowerCase().includes('sweet')
    );
    break;
  case '😖 Tangy':
    const productFlavourTangy = product.dataset.flavourClean || product.dataset.flavour;
            matchesThisFilter = productFlavourTangy && (
      productFlavourTangy === '😖 Tangy' ||
      productFlavourTangy.toLowerCase().includes('tangy')
    );
    break;
  case '🍉 Juicy':
    const productTextureJuicy = product.dataset.textureClean || product.dataset.texture;
            matchesThisFilter = productTextureJuicy && (
      productTextureJuicy === '🍉 Juicy' ||
      productTextureJuicy.toLowerCase().includes('juicy')
    );
    break;
  case '🍦 Creamy':
    const productTextureCreamy = product.dataset.textureClean || product.dataset.texture;
            matchesThisFilter = productTextureCreamy && (
      productTextureCreamy === '🍦 Creamy' ||
      productTextureCreamy.toLowerCase().includes('creamy')
    );
    break;
        }
        
        // If any filter matches, show the product (OR logic)
        if (matchesThisFilter) {
    shouldShow = true;
    break;
        }
      }
    }

    // Selected filter - show only products with quantity > 0
    if (filters.selected) {
      const qtyInput = product.querySelector('.juo-box__product-qty-input');
      const hasQuantity = qtyInput && parseInt(qtyInput.value) > 0;
      shouldShow = shouldShow && hasQuantity;
    }

    product.style.display = shouldShow ? '' : 'none';
    if (shouldShow) visibleProducts++;
  });

  // Then sort the visible products
  productArray = productArray.filter(p => p.style.display !== 'none');

  // OPTIMIZATION: Calculate hash once instead of repeatedly
  // Extract hash and strip any UTM parameters (e.g., #14809221726578?utm_source=...)
  const hashProductId = window.location.hash.slice(1).split('?')[0];
  const targetProductId = hashProductId ? `product-${hashProductId}` : null;
  
  // Get related products for the hash product
  let relatedProductIds = [];
  if (targetProductId) {
    const hashElement = document.querySelector(`#${targetProductId}`);
    const relatedProductsData = hashElement?.getAttribute('data-related-products');
    if (relatedProductsData && relatedProductsData.trim()) {
      relatedProductIds = relatedProductIds.concat(relatedProductsData.split(',').map(id => `product-${id.trim()}`).filter(id => id));
    }
  }
  
  // Get cookie-approved products (maintain newest-first order)
  const approvedProducts = getApprovedHashProducts(); // Array of product IDs, newest first
  const approvedProductIds = approvedProducts.map(id => `product-${id}`);
  
  // Detect UTM gift products (highest priority)
  let utmGiftProductIds = [];
  const utmSource = getUtmSource(); // Check URL, sessionStorage, and 30-day cookie
  
  if (utmSource) {
    // Find products with showForUtm matching this UTM
    Object.keys(HASH_ONLY_CONFIG).forEach(productId => {
      const config = HASH_ONLY_CONFIG[productId];
      if (config.showForUtm && config.showForUtm.includes(utmSource)) {
        utmGiftProductIds.push(`product-${productId}`);
      }
    });
  }

  if (activeFilters.main === 'price-low' || activeFilters.main === 'price-high') {
    // Sort by price
    productArray.sort((a, b) => {
      // TIER 0: UTM GIFT PRODUCTS (highest priority)
      const aIsUtmGift = utmGiftProductIds.includes(a.id);
      const bIsUtmGift = utmGiftProductIds.includes(b.id);
      if (aIsUtmGift && !bIsUtmGift) return -1;
      if (!aIsUtmGift && bIsUtmGift) return 1;
      
      // TIER 1: HASH PRODUCT PRIORITY
      if (targetProductId) {
        if (a.id === targetProductId && b.id !== targetProductId) return -1;
        if (a.id !== targetProductId && b.id === targetProductId) return 1;
      }
      
      // TIER 2: RELATED PRODUCTS
      const aIsRelated = relatedProductIds.includes(a.id);
      const bIsRelated = relatedProductIds.includes(b.id);
      if (aIsRelated && !bIsRelated) return -1;
      if (!aIsRelated && bIsRelated) return 1;
      
      // TIER 3: COOKIE-APPROVED PRODUCTS (maintain order)
      const aApprovedIndex = approvedProductIds.indexOf(a.id);
      const bApprovedIndex = approvedProductIds.indexOf(b.id);
      const aIsApproved = aApprovedIndex !== -1;
      const bIsApproved = bApprovedIndex !== -1;
      if (aIsApproved && !bIsApproved) return -1;
      if (!aIsApproved && bIsApproved) return 1;
      if (aIsApproved && bIsApproved) return aApprovedIndex - bApprovedIndex; // Maintain cookie order
      
      // TIER 4: FEATURED PRODUCTS (maintain array order)
      const aProductId = a.id.replace('product-', '');
      const bProductId = b.id.replace('product-', '');
      const aFeaturedIndex = FEATURED_PRODUCTS.indexOf(aProductId);
      const bFeaturedIndex = FEATURED_PRODUCTS.indexOf(bProductId);
      const aIsFeatured = aFeaturedIndex !== -1;
      const bIsFeatured = bFeaturedIndex !== -1;
      if (aIsFeatured && !bIsFeatured) return -1;
      if (!aIsFeatured && bIsFeatured) return 1;
      if (aIsFeatured && bIsFeatured) return aFeaturedIndex - bFeaturedIndex; // Maintain featured order
      
      const priceA = parseFloat(a.dataset.price || 0);
      const priceB = parseFloat(b.dataset.price || 0);
      return activeFilters.main === 'price-low' ? priceA - priceB : priceB - priceA;
    });
} else {
    // Sort by popularity first (best sellers at top), then by collection position
    productArray.sort((a, b) => {
      // TIER 0: UTM GIFT PRODUCTS (highest priority)
      const aIsUtmGift = utmGiftProductIds.includes(a.id);
      const bIsUtmGift = utmGiftProductIds.includes(b.id);
      if (aIsUtmGift && !bIsUtmGift) return -1;
      if (!aIsUtmGift && bIsUtmGift) return 1;
      
      // TIER 1: HASH PRODUCT PRIORITY
      if (targetProductId) {
        if (a.id === targetProductId && b.id !== targetProductId) return -1;
        if (a.id !== targetProductId && b.id === targetProductId) return 1;
      }
      
      // TIER 2: RELATED PRODUCTS
      const aIsRelated = relatedProductIds.includes(a.id);
      const bIsRelated = relatedProductIds.includes(b.id);
      if (aIsRelated && !bIsRelated) return -1;
      if (!aIsRelated && bIsRelated) return 1;
      
      // TIER 3: COOKIE-APPROVED PRODUCTS (maintain newest-first order)
      const aApprovedIndex = approvedProductIds.indexOf(a.id);
      const bApprovedIndex = approvedProductIds.indexOf(b.id);
      const aIsApproved = aApprovedIndex !== -1;
      const bIsApproved = bApprovedIndex !== -1;
      if (aIsApproved && !bIsApproved) return -1;
      if (!aIsApproved && bIsApproved) return 1;
      if (aIsApproved && bIsApproved) return aApprovedIndex - bApprovedIndex; // Maintain cookie order (newest first)
      
      // TIER 4: FEATURED PRODUCTS (maintain array order)
      const aProductId = a.id.replace('product-', '');
      const bProductId = b.id.replace('product-', '');
      const aFeaturedIndex = FEATURED_PRODUCTS.indexOf(aProductId);
      const bFeaturedIndex = FEATURED_PRODUCTS.indexOf(bProductId);
      const aIsFeatured = aFeaturedIndex !== -1;
      const bIsFeatured = bFeaturedIndex !== -1;
      if (aIsFeatured && !bIsFeatured) return -1;
      if (!aIsFeatured && bIsFeatured) return 1;
      if (aIsFeatured && bIsFeatured) return aFeaturedIndex - bFeaturedIndex; // Maintain featured order
      
      // TIER 5: BEST SELLERS
      const tagsA = a.dataset.tags ? a.dataset.tags.split(',').map(t => t.trim()) : [];
      const tagsB = b.dataset.tags ? b.dataset.tags.split(',').map(t => t.trim()) : [];
      
      const isBestSellerA = tagsA.includes('filter_popular');
      const isBestSellerB = tagsB.includes('filter_popular');
      
      if (isBestSellerA && !isBestSellerB) return -1;
      if (!isBestSellerA && isBestSellerB) return 1;
      
      // TIER 6: COLLECTION POSITION
      const posA = parseInt(a.getAttribute('data-collection-position')) || 999;
      const posB = parseInt(b.getAttribute('data-collection-position')) || 999;
      return posA - posB;
    });
  }

  // Reorder the DOM
  productArray.forEach(product => {
    productList.appendChild(product);
  });

  // Show products after sorting completes (prevents CLS flicker)
  // Use requestAnimationFrame to ensure DOM reorder is painted before revealing
  requestAnimationFrame(() => {
    if (!productList.classList.contains('sorted')) {
      productList.classList.add('sorted');
    }
  });

  // Show/hide no results message
  noResults.style.display = visibleProducts === 0 ? 'block' : 'none';
}



    // Set up filter change listeners
    filters.forEach(filter => {
      filter.addEventListener('change', (e) => {
        const filterType = e.target.getAttribute('data-filter');
        activeFilters[filterType] = e.target.value;
        filterProducts();
      });
    });
    
    // Apply default sorting on initial load
    filterProducts(true);
  }

  // Initialize filters when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFilters);
  } else {
    initFilters();
  }
})();


(function () {
  const n = { checkboxId: "juo-box-subscribe", select: ".juo-box__select" };
  let c = false;

  function i() {
    function u() {
      const r = document.getElementById(n.checkboxId),
        s = document.querySelector(n.select);

      if (r) {
        if (r.checked) a(r, s);

        if (!c) {
          c = true;

          r.addEventListener("click", () => {
            a(r, s);
          });

          s.addEventListener("change", () => {
            r.checked = true;
            e(d());
          });
        }
      }
    }

    function d() {
      const r = document.getElementById(n.checkboxId),
        s = document.querySelector(n.select);
      return r == null ? null : s && r.checked ? s.value : null;
    }

    function a(r, s) {
      if (r.checked) {
        s.classList.add("juo-box__select--active");
        e(d());
      } else {
        s.classList.remove("juo-box__select--active");
        e(null);
      }
    }

    u();
    window.addEventListener("load", u);
  }

  function e(u) {
    document.dispatchEvent(new CustomEvent("juo-box:selected-selling-plan", { detail: { sellingPlanId: u } }));
  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", i) : i();
})();

(function () {
  const n = new Intl.NumberFormat(window.Shopify.locale, { style: "currency", currency: window.Shopify.currency.active });

  function c(e) {
    return n.format(e);
  }

  async function i(e, u, d, a) {
    try {
      console.log('[Price Calc] START - qty:', u, 'items:', d?.length);
      
      // Safety check
      if (!e || !e.prices) {
        console.error('[Price Calc] Missing box data or prices');
        return;
      }

      let r = 0,
        s = 0;
      const v = !!a;

      // PERFORMANCE FIX: Use only builder items for pricing - cart sync happens when drawer closes
      let allItems = [...d]; // Builder items only

      allItems.forEach(({ variantId: g, qty: t }) => {
        if (v) {
          const o = e.variants.flat().find((p) => parseInt(g, 10) === p.id);
          if (o != null) {
            const p = o.selling_plan_allocations.find((f) => f.selling_plan_id === parseInt(a, 10));
            if (p != null) {
              r += p.price * t;
              return;
            }
          }
        }

        const price = e.prices[g];
        if (price != null && !isNaN(price)) {
          r += price * t;
        }
      });

      console.log('[Price Calc] Total raw price:', r);

      const m = e.tiers
          .sort(function (g, t) {
            return t.productsCount - g.productsCount;
          })
          .find(function (g) {
            return g.productsCount <= u;
          });
        
      const b = e.freeProduct.price != null && v ? e.freeProduct.price : 0;
      
      // Clean discount logic: tier first, then toggle-based fallback
      let l;
      if (m) {
        l = m.value;  // 4+ items: use tier (existing logic)
      } else if (u > 0) {
        // 1-3 items: check toggle for correct %
        const isMember = document.querySelector('input[name="pricing-type"][value="member"]')?.checked;
        l = isMember ? 50 : 35;  // Member: 50%, Non-member: 35%
      } else {
        l = 0;  // 0 items: no discount
      }

      console.log('[Price Calc] Discount %:', l);

      s = parseInt(r * l * 0.01, 10) + b;
      const y = r - s + b,
        h = u > 0 ? r + b : 0;

      console.log('[Price Calc] Final price (cents):', y, 'Compare:', h);

      const totalPriceText = c(y / 100);
      const comparePriceText = h === y ? "" : c(h / 100);
      const savingsText = s > 0 ? c(s / 100) : "";

      console.log('[Price Calc] Formatted:', totalPriceText);

      document.querySelector('[data-ref="total-price"]').innerText = totalPriceText;
      document.querySelector('[data-ref="compare-price"]').innerText = comparePriceText;
      document.querySelector('[data-ref="savings"]').innerText = savingsText;

      console.log('[Price Calc] COMPLETE - Set to:', totalPriceText);

      s > 0 &&
        document.dispatchEvent(new CustomEvent("juo-box:savings-calculated", { detail: { savings: s } }));
    } catch (error) {
      console.error('[Price Calc] Error:', error);
    }
  }

  document.addEventListener("juo-box:update-prices", async (e) => {
    // If data is missing, load it from the DOM
    let boxData = e.detail.data;
    if (!boxData) {
      const dataElement = document.getElementById('juo-box-data');
      if (dataElement) {
        const rawData = JSON.parse(dataElement.textContent);
        const prices = {};
        rawData.ids.forEach((id) => {
          const variant = rawData.variants.find((v) => v.id == id);
          if (variant) prices[id] = variant.price;
        });
        boxData = {
          prices: prices,
          tiers: rawData.tiers,
          sellingPlans: rawData.sellingPlans,
          product: rawData.product,
          freeProduct: rawData.freeProduct || {},
          variants: rawData.variants,
          minItemsCount: rawData.minItemsCount,
          moneyFormat: rawData.moneyFormat
        };
      }
    }
    await i(boxData, e.detail.totalQty, e.detail.formValues, e.detail.sellingPlanId);
  });
})();

// ===== A/B TEST: 3-ITEM MINIMUM LOGIC =====
(function() {
  // A/B Test switching functions
  window.show3ItemTest = function() {
    
    // Get member status
    const isActiveSubscriber = window.customer && window.customer.tags && 
      (window.customer.tags.includes('active_subscriber') ||
       window.customer.tags.includes('Priority_Pass') ||
       window.customer.tags.includes('new_member'));
    
    // Load 3-item data based on member status
    const dataElementId = isActiveSubscriber ? 'juo-box-data-3item-member' : 'juo-box-data-3item';
    const dataElement = document.getElementById(dataElementId);
    
    if (dataElement) {
      try {
        const testData = JSON.parse(dataElement.textContent);
        
        // Replace current box data with 3-item data
        window.juoBoxData = testData;
        
        // Re-initialize with new data
        document.dispatchEvent(new CustomEvent("juo-box:init-progress-bar", { detail: { tiers: testData.tiers } }));
        
        // Show 3-item messaging
        show3ItemMessaging();
        
        // Store test variant
        sessionStorage.setItem('juo_ab_test_variant', '3item');
        
        console.log('3-Item Test Data Loaded:', testData);
      } catch (error) {
        console.error('Error loading 3-item test data:', error);
      }
    }
  };
  
  window.show2ItemTest = function() {
    console.log('Switching to 2-Item Test Variant');
    
    // Get member status
    const isActiveSubscriber = window.customer && window.customer.tags && 
      (window.customer.tags.includes('active_subscriber') ||
       window.customer.tags.includes('Priority_Pass') ||
       window.customer.tags.includes('new_member'));
    
    // Load 2-item data based on member status
    const dataElementId = isActiveSubscriber ? 'juo-box-data-2item-member' : 'juo-box-data-2item';
    const dataElement = document.getElementById(dataElementId);
    
    if (dataElement) {
      try {
        const testData = JSON.parse(dataElement.textContent);
        
        // Replace current box data with 2-item data
        window.juoBoxData = testData;
        
        // Re-initialize with new data
        document.dispatchEvent(new CustomEvent("juo-box:init-progress-bar", { detail: { tiers: testData.tiers } }));
        
        // Show 2-item messaging
        show2ItemMessaging();
        
        // Store test variant
        sessionStorage.setItem('juo_ab_test_variant', '2item');
        
        console.log('2-Item Test Data Loaded:', testData);
      } catch (error) {
        console.error('Error loading 2-item test data:', error);
      }
    }
  };
  
  window.show4ItemControl = function() {
    console.log('Switching to 4-Item Control Variant');
    
    // Get member status  
    const isActiveSubscriber = window.customer && window.customer.tags && 
      (window.customer.tags.includes('active_subscriber') ||
       window.customer.tags.includes('Priority_Pass') ||
       window.customer.tags.includes('new_member'));
    
    // Load original data based on member status
    const dataElementId = isActiveSubscriber ? 'juo-box-data-member' : 'juo-box-data';
    const dataElement = document.getElementById(dataElementId);
    
    if (dataElement) {
      try {
        const controlData = JSON.parse(dataElement.textContent);
        
        // Replace current box data with original 4-item data
        window.juoBoxData = controlData;
        
        // Re-initialize with original data
        document.dispatchEvent(new CustomEvent("juo-box:init-progress-bar", { detail: { tiers: controlData.tiers } }));
        
        // Show 4-item messaging
        show4ItemMessaging();
        
        // Store test variant
        sessionStorage.setItem('juo_ab_test_variant', '4item');
        
        console.log('4-Item Control Data Loaded:', controlData);
      } catch (error) {
        console.error('Error loading 4-item control data:', error);
      }
    }
  };
  
  function show2ItemMessaging() {
    // Hide all 4-item messages
    const fourItemElements = [
      '.juo-box__tiers-description--zero-items',
      '.juo-box__tiers-description--first-item', 
      '.juo-box__tiers-description--completed'
    ];
    fourItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'none';
    });
    
    // Hide all 3-item messages
    const threeItemElements = [
      '.juo-box__tiers-description--zero-items-3item',
      '.juo-box__tiers-description--first-item-3item',
      '.juo-box__tiers-description--completed-3item'
    ];
    threeItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'none';
    });
    
    // Show 2-item messages
    const twoItemElements = [
      '.juo-box__tiers-description--zero-items-2item',
      '.juo-box__tiers-description--first-item-2item',
      '.juo-box__tiers-description--completed-2item'
    ];
    twoItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'block';
    });
  }
  
  function show3ItemMessaging() {
    // Hide all 4-item messages
    const fourItemElements = [
      '.juo-box__tiers-description--zero-items',
      '.juo-box__tiers-description--first-item', 
      '.juo-box__tiers-description--completed'
    ];
    fourItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'none';
    });
    
    // Hide all 2-item messages
    const twoItemElements = [
      '.juo-box__tiers-description--zero-items-2item',
      '.juo-box__tiers-description--first-item-2item',
      '.juo-box__tiers-description--completed-2item'
    ];
    twoItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'none';
    });
    
    // Show 3-item messages
    const threeItemElements = [
      '.juo-box__tiers-description--zero-items-3item',
      '.juo-box__tiers-description--first-item-3item',
      '.juo-box__tiers-description--completed-3item'
    ];
    threeItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'block';
    });
  }
  
  function show4ItemMessaging() {
    // Hide all 3-item messages
    const threeItemElements = [
      '.juo-box__tiers-description--zero-items-3item',
      '.juo-box__tiers-description--first-item-3item',
      '.juo-box__tiers-description--completed-3item'
    ];
    threeItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'none';
    });
    
    // Hide all 2-item messages
    const twoItemElements = [
      '.juo-box__tiers-description--zero-items-2item',
      '.juo-box__tiers-description--first-item-2item',
      '.juo-box__tiers-description--completed-2item'
    ];
    twoItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'none';
    });
    
    // Show 4-item messages (they're shown by default, but ensure they're visible)
    const fourItemElements = [
      '.juo-box__tiers-description--zero-items',
      '.juo-box__tiers-description--first-item',
      '.juo-box__tiers-description--completed'
    ];
    fourItemElements.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.style.display = 'block';
    });
  }
  
  // Auto-initialize based on Intelligems or stored preference
  function initializeABTest() {
    // Check for stored preference first
    const storedVariant = sessionStorage.getItem('juo_ab_test_variant');
    
    if (storedVariant === '2item') {
      show2ItemTest();
    } else if (storedVariant === '3item') {
      show3ItemTest();
    } else if (storedVariant === '4item') {
      show4ItemControl();
    } else {
      // Default to 3-item if no stored preference
      // Intelligems will call show2ItemTest() or show4ItemControl() if user is in test group
      show3ItemTest();
    }
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeABTest);
  } else {
    initializeABTest();
  }
})();

// ============================================================================
// LOCKED PRODUCT SYSTEM - UTM-Based Targeting with Klaviyo Unlock
// ============================================================================

// Get UTM source from URL, sessionStorage, or 30-day cookie (captured by theme.liquid)
function getUtmSource() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlUtm = urlParams.get('utm_source') || urlParams.get('tw_source');
  if (urlUtm) return urlUtm;
  
  // Check hash parameters (e.g., #11623597179040?utm_source=babgift)
  const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
  const hashUtm = hashParams.get('utm_source') || hashParams.get('tw_source');
  if (hashUtm) return hashUtm;
  
  // Check sessionStorage (current session)
  const sessionUtm = sessionStorage.getItem('ghf_utm_source');
  if (sessionUtm) return sessionUtm;
  
  // Check 30-day cookie (persists across sessions)
  const value = "; " + document.cookie;
  const parts = value.split("; ghf_utm_source=");
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  
  return null;
}

// Check if product is unlocked (localStorage for persistence)
function isProductUnlocked(productId) {
  return localStorage.getItem(`ghf_unlocked_${productId}`) === 'true';
}

// Check if locked product should show based on targeting rules
function shouldShowLockedProduct(productId, config) {
  // If not using alwaysShow, use existing hash product logic
  if (!config.alwaysShow) {
    return REVEALED_PRODUCTS.has(productId) || isProductApproved(productId);
  }
  
  // Check UTM targeting
  if (config.showForUtm && config.showForUtm.length > 0) {
    const utmSource = getUtmSource();
    if (!utmSource) return false;
    
    const matchesUtm = config.showForUtm.some(source => 
      utmSource.toLowerCase().includes(source.toLowerCase())
    );
    if (!matchesUtm) return false;
  }
  
  // Check member-only requirement
  if (config.memberOnly) {
    const isMemberSelected = document.querySelector('input[name="pricing-type"][value="member"]')?.checked;
    if (!isMemberSelected) return false;
  }
  
  return true;
}

// Apply lock overlay to product - add class and make entire card clickable
function applyLockOverlay(productElement, productId, config) {
  if (productElement.classList.contains('hash-product-locked')) return;
  
  productElement.classList.add('hash-product-locked');
  
  // Track submission count for 2-step form
  let submitCount = 0;
  
  // Listen for Klaviyo form completion (2-step: email + SMS)
  const formListener = function(e) {
    // Accept BOTH mobile and desktop form IDs
    const isMobileForm = e.detail && e.detail.formId === config.klaviyoFormId;
    const isDesktopForm = e.detail && e.detail.formId === config.klaviyoFormIdDesktop;
    
    if (isMobileForm || isDesktopForm) {
      // Count 'submit' events (not 'stepSubmit')
      if (e.detail.type === 'submit') {
        submitCount++;
        console.log(`[Unlock] Submit count: ${submitCount}/2`);
        
        // Unlock after BOTH steps are submitted (2nd submit event)
        if (submitCount >= 2) {
          console.log('[Unlock] Both steps completed - unlocking product');
          unlockProduct(productId);
          window.removeEventListener('klaviyoForms', formListener);
          // Remove click listener so product behaves normally
          productElement.removeEventListener('click', cardClickHandler);
        }
      }
    }
  };
  
  window.addEventListener('klaviyoForms', formListener);
  
  // Make entire card clickable to open Klaviyo popup
  const cardClickHandler = function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Clear any text selection from mobile tap (prevents blue bar in popup)
    if (window.getSelection) {
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        selection.removeAllRanges();
      }
    }
    
    // Blur any focused element
    if (document.activeElement && document.activeElement !== document.body) {
      document.activeElement.blur();
    }
    
    // Reset submit count when opening form
    submitCount = 0;
    
    // Open Klaviyo popup (device-specific)
    const formId = getKlaviyoFormId(config);
    if (formId && window._klOnsite) {
      window._klOnsite.push(['openForm', formId]);
      
      // Clear selection again after Klaviyo renders (prevents blue bar in popup)
      setTimeout(() => {
        if (window.getSelection) {
          const selection = window.getSelection();
          if (selection && selection.rangeCount > 0) {
            selection.removeAllRanges();
          }
        }
      }, 100);
      
      // Clear again after animation completes
      setTimeout(() => {
        if (window.getSelection) {
          const selection = window.getSelection();
          if (selection && selection.rangeCount > 0) {
            selection.removeAllRanges();
          }
        }
      }, 500);
    }
  };
  
  productElement.addEventListener('click', cardClickHandler);
}

// Remove lock overlay from product
function removeLockOverlay(productElement) {
  productElement.classList.remove('hash-product-locked', 'hash-product-unlocking');
  productElement.classList.add('hash-product-unlocked');
}

// Unlock product (remove overlay + save state)
function unlockProduct(productId) {
  const productElement = document.querySelector(`#product-${productId}`);
  if (!productElement) return;
  
  // Save unlock state to localStorage
  localStorage.setItem(`ghf_unlocked_${productId}`, 'true');
  
  // Animate unlock
  productElement.classList.add('hash-product-unlocking');
  
  setTimeout(() => {
    removeLockOverlay(productElement);
    
    // Scroll to products section on mobile after unlock
    if (isMobileDevice()) {
      const productsSection = document.querySelector('.juo-box__products');
      if (productsSection) {
        const yOffset = -100;
        const y = productsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
      }
    }
  }, 500);
}
